import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CarId: any;
  FinanceProductId: any;
  TrimCode: any;
  TrimId: any;
};

export enum Access {
  Denied = 'denied',
  Error = 'error',
  Granted = 'granted',
  /** @deprecated No longer needed */
  Mismatch = 'mismatch',
  Pending = 'pending'
}

export type AdditionalGovernmentTax = {
  __typename?: 'AdditionalGovernmentTax';
  money: Money;
  name: Scalars['String'];
};

export type AgeRange = {
  __typename?: 'AgeRange';
  value: Scalars['String'];
};

export type ApexxPaymentResponse = Payment & {
  __typename?: 'ApexxPaymentResponse';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  attributes?: Maybe<AppointmentAttributes>;
  /** @deprecated use attributes.comments */
  comments?: Maybe<Scalars['String']>;
  preferredDate?: Maybe<Scalars['String']>;
  preferredTime?: Maybe<Scalars['String']>;
  /** @deprecated use attributes.purchaseTime */
  purchaseTime?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
};

export type AppointmentAttributes = {
  __typename?: 'AppointmentAttributes';
  comments?: Maybe<Scalars['String']>;
  purchaseTime?: Maybe<Scalars['String']>;
  salesConsultant?: Maybe<Scalars['String']>;
  salesConsultantEmail?: Maybe<Scalars['String']>;
};

export type AuthenticationMutation = {
  __typename?: 'AuthenticationMutation';
  initForgotPassword: Scalars['Boolean'];
  login: Session;
  register: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
};


export type AuthenticationMutationInitForgotPasswordArgs = {
  email: Scalars['String'];
};


export type AuthenticationMutationLoginArgs = {
  dealId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};


export type AuthenticationMutationRegisterArgs = {
  data: RegisterFormData;
};


export type AuthenticationMutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type AuthenticationQuery = {
  __typename?: 'AuthenticationQuery';
  isPasswordResetTokenValid: Scalars['Boolean'];
  registerForm: MyAccountJsonSchemaForm;
};


export type AuthenticationQueryIsPasswordResetTokenValidArgs = {
  resetToken: Scalars['String'];
};


export type AuthenticationQueryRegisterFormArgs = {
  dealId?: InputMaybe<Scalars['String']>;
};

export type ByoCarAttributes = {
  __typename?: 'BYOCarAttributes';
  exterior?: Maybe<Exterior>;
  interior?: Maybe<Interior>;
  stockInfo?: Maybe<StockInfo>;
  variantName?: Maybe<Scalars['String']>;
  vehicleImage?: Maybe<Scalars['String']>;
};

export type Background = {
  __typename?: 'Background';
  attributes?: Maybe<BackgroundAttributes>;
  code: Scalars['String'];
  image?: Maybe<Array<Maybe<Image>>>;
  shortname: Scalars['String'];
};

export type BackgroundAttributes = {
  __typename?: 'BackgroundAttributes';
  oemcode: Scalars['String'];
};

export type Badge = {
  __typename?: 'Badge';
  image: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type BodyStyle = {
  __typename?: 'BodyStyle';
  attributes?: Maybe<BodyStyleAttributes>;
  code: Scalars['String'];
  image?: Maybe<Image>;
  interiorimage?: Maybe<Image>;
  rearimage?: Maybe<Image>;
  sideimage?: Maybe<Image>;
};

export type BodyStyleAttributes = {
  __typename?: 'BodyStyleAttributes';
  bodyStyleType?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `shortname`. */
  label?: Maybe<Scalars['String']>;
  longdescription?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
};

export type BodyStyleResult = {
  __typename?: 'BodyStyleResult';
  bodyStyle: BodyStyle;
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  financeFormInput?: Maybe<FinanceFormInputData>;
  nextFilters?: Maybe<ResponseFilters>;
  quoteResult: QuoteResult;
};


export type BodyStyleResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type BreakdownBlock = {
  __typename?: 'BreakdownBlock';
  blocks: Array<Array<BreakdownBlockRow>>;
  currency: Scalars['String'];
};

export type BreakdownBlockRow = {
  __typename?: 'BreakdownBlockRow';
  highlighted: Scalars['Boolean'];
  isNegative?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  shouldBeFormatted?: Maybe<Scalars['Boolean']>;
  shouldDisplayDivider?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  toolTip?: Maybe<Tooltip>;
  value: Scalars['String'];
};

export type BudgetFilterForm = {
  __typename?: 'BudgetFilterForm';
  load: BudgetFilterFormResponse;
  priceCalculation: BudgetFilterFormResponse;
};


export type BudgetFilterFormLoadArgs = {
  input?: InputMaybe<BudgetFilterFormInput>;
};


export type BudgetFilterFormPriceCalculationArgs = {
  input?: InputMaybe<BudgetFilterFormInput>;
};

export type BudgetFilterFormInput = {
  customerType?: InputMaybe<Scalars['String']>;
  deposit?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Int']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Array<Scalars['String']>>;
  repayment?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
};

export type BudgetFilterFormResponse = {
  __typename?: 'BudgetFilterFormResponse';
  form: BudgetFilterFormSchema;
  price: BudgetFilterPrice;
};

export type BudgetFilterFormSchema = {
  __typename?: 'BudgetFilterFormSchema';
  formData: Scalars['String'];
  schema: Scalars['String'];
  uiSchema: Scalars['String'];
};

export type BudgetFilterPrice = {
  __typename?: 'BudgetFilterPrice';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  grossAmount: Scalars['Float'];
  label?: Maybe<Scalars['String']>;
};

export type CoeCategoryAmount = {
  __typename?: 'COECategoryAmount';
  amount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type Car = {
  __typename?: 'Car';
  attributes?: Maybe<CarAttributes>;
  bodyStyle?: Maybe<BodyStyle>;
  byoCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  defaultSelectedFeatureIds: Array<Scalars['String']>;
  engine?: Maybe<Engine>;
  image?: Maybe<Image>;
  keyFeatures: Array<Feature>;
  keyFeaturesCategories: Array<FeatureCategory>;
  model?: Maybe<Model>;
  /** @deprecated Use `carConfig.prices instead`. */
  prices: Array<Price>;
  specPack?: Maybe<SpecPack>;
  specPacksForAllVariants?: Maybe<Array<SpecPackResult>>;
  standardFeatures: Array<Feature>;
  standardFeaturesCategories: Array<FeatureCategory>;
  trim?: Maybe<Trim>;
  variant?: Maybe<Variant>;
};

export type CarAttributes = {
  __typename?: 'CarAttributes';
  brochureFile?: Maybe<Scalars['String']>;
  /** @deprecated Use `DealAttributes.PaymentFee instead`. */
  coeCategoryAmount?: Maybe<Array<Maybe<CoeCategoryAmount>>>;
  externalSku?: Maybe<Scalars['String']>;
  freebies?: Maybe<Array<Maybe<Freebies>>>;
  hasIndicativePrice?: Maybe<Scalars['Boolean']>;
  insurance?: Maybe<Array<Price>>;
  isPreOrder?: Maybe<Scalars['Boolean']>;
  learnMoreLink?: Maybe<Scalars['String']>;
  priceLabel?: Maybe<Scalars['String']>;
  promotionalLabel1?: Maybe<Scalars['String']>;
  promotionalLabel2?: Maybe<Scalars['String']>;
  specDescription?: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicleDisplayName?: Maybe<Scalars['String']>;
  withoutCoe?: Maybe<Scalars['Boolean']>;
};

export type CarConfiguration = {
  __typename?: 'CarConfiguration';
  car: Car;
  finance: FinanceResult;
  prices: Prices;
};


export type CarConfigurationFinanceArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};

export type CarPrice = {
  __typename?: 'CarPrice';
  finalPrice: Array<Price>;
  offers: Offers;
  originalPrice: Array<Price>;
  totalDiscount: Array<Money>;
};

export type CatalogResult = {
  __typename?: 'CatalogResult';
  count?: Maybe<Scalars['Int']>;
  financeFormInput?: Maybe<FinanceFormInputData>;
  nodes: Array<Maybe<TrimResult>>;
  searchFacets?: Maybe<Array<Maybe<SearchFacet>>>;
};

export type ComplexMiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'ComplexMiscellaneousOptionDefinition';
  category: Scalars['String'];
  categoryName: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  descriptionEditable: Scalars['Boolean'];
  price: Money;
  priceEditable: Scalars['Boolean'];
};

export type ComplexMiscellaneousOptionInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['Int'];
  taxable?: InputMaybe<Scalars['Boolean']>;
};

export enum ComponentName {
  Checkout = 'checkout',
  Configurator = 'configurator',
  Fincalc = 'fincalc',
  Insurance = 'insurance',
  Myaccount = 'myaccount',
  Se = 'se'
}

export type Configurator = {
  __typename?: 'Configurator';
  customizeCarWithQuote: CustomizedCarWithQuote;
  similarStockCars?: Maybe<Array<StockCar>>;
};


export type ConfiguratorCustomizeCarWithQuoteArgs = {
  carId: Scalars['CarId'];
  needsInteraction: Scalars['Boolean'];
  selectedFeatureIds: FeatureIdsInput;
};


export type ConfiguratorSimilarStockCarsArgs = {
  carId: Scalars['CarId'];
  dealerId?: InputMaybe<Scalars['String']>;
  needsInteraction: Scalars['Boolean'];
  selectedFeatureIds: FeatureIdsInput;
};

export type CreditOption = {
  __typename?: 'CreditOption';
  details: Array<CreditOptionsDetails>;
  id: Scalars['String'];
  lender: Scalars['String'];
};

export type CreditOptions = {
  __typename?: 'CreditOptions';
  deal: Deal;
  disclaimers: Array<FinanceInfoDisclaimer>;
  options: Array<CreditOption>;
};

export type CreditOptionsDetails = {
  __typename?: 'CreditOptionsDetails';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  attributes?: Maybe<CustomerAttributes>;
  companyName?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated use attributes.identificationNumber */
  identificationNumber?: Maybe<Scalars['String']>;
  /** @deprecated use attributes.identificationType */
  identificationType?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** @deprecated use attributes.marketingInformation */
  marketingInformation?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  /** @deprecated use attributes.salutation */
  salutation?: Maybe<Scalars['String']>;
};

export type CustomerAttributes = {
  __typename?: 'CustomerAttributes';
  address?: Maybe<Scalars['String']>;
  areaCode?: Maybe<Scalars['String']>;
  areaCodeKey?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customerTypeKey?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  drivingLicenseDate?: Maybe<Scalars['String']>;
  identificationNumber?: Maybe<Scalars['String']>;
  identificationType?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  marketingCommercialConsent?: Maybe<Array<Scalars['String']>>;
  marketingInformation?: Maybe<Scalars['Boolean']>;
  occupationType?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  preferredContactMethod?: Maybe<Scalars['String']>;
  preferredDealer?: Maybe<Scalars['String']>;
  preferredDealerKey?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type CustomizedCarConfiguration = {
  __typename?: 'CustomizedCarConfiguration';
  additionalGovernmentTaxes: Array<AdditionalGovernmentTax>;
  availableFeatureCategories: Array<FeatureCategory>;
  availableFeatures: Array<Feature>;
  car?: Maybe<Car>;
  deliveryTimeFrame?: Maybe<DeliveryTimeFrame>;
  disclaimers: Array<Disclaimer>;
  finance: FinanceResult;
  financeFormInput?: Maybe<FinanceFormInputData>;
  images: Array<Image>;
  insurance?: Maybe<InsuranceResult>;
  /** @deprecated Use `quote.prices`. */
  prices: Prices;
  quote: QuoteMinimal;
  reservationFee?: Maybe<ReservationFee>;
  selectedCurrency?: Maybe<Scalars['String']>;
  /** @deprecated Use `selectedFeatures`. */
  selectedFeatureIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedFeatures: SelectedFeatures;
  selectedFeaturesId?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedFeaturesInput?: Maybe<SelectedFeatures>;
  selectedSections?: Maybe<Array<Maybe<FeatureSection>>>;
  similarStockCars?: Maybe<Array<StockCar>>;
  stockAvailability?: Maybe<Scalars['Boolean']>;
  stockInfo?: Maybe<StockInfo>;
  /** @deprecated Use `prices.totalConfiguration`. */
  totalConfiguration: Array<Price>;
  /** @deprecated Use `prices.totalFeatures`. */
  totalFeatures: Array<Price>;
  /** @deprecated Use `prices.totalPrice`. */
  totalPrice: Array<Price>;
};


export type CustomizedCarConfigurationDisclaimersArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type CustomizedCarConfigurationFinanceArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type CustomizedCarConfigurationInsuranceArgs = {
  carId?: InputMaybe<Scalars['CarId']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};

export type CustomizedCarWithQuote = {
  __typename?: 'CustomizedCarWithQuote';
  additionalGovernmentTaxes: Array<AdditionalGovernmentTax>;
  availableFeatureCategories: Array<FeatureCategory>;
  availableFeatures: Array<Feature>;
  car?: Maybe<Car>;
  deliveryTimeFrame?: Maybe<DeliveryTimeFrame>;
  financeFormInput?: Maybe<FinanceFormInputData>;
  images: Array<Image>;
  insurance?: Maybe<InsuranceResult>;
  quote: QuoteMinimal;
  reservationFee?: Maybe<ReservationFee>;
  selectedCurrency?: Maybe<Scalars['String']>;
  selectedFeatures: SelectedFeatures;
  selectedFeaturesId?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedFeaturesInput?: Maybe<SelectedFeatures>;
  selectedSections?: Maybe<Array<Maybe<FeatureSection>>>;
  stockAvailability?: Maybe<Scalars['Boolean']>;
  stockInfo?: Maybe<StockInfo>;
};


export type CustomizedCarWithQuoteInsuranceArgs = {
  carId?: InputMaybe<Scalars['CarId']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type CustomizedCarWithQuoteQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
  vehicleConfigurationUrl?: InputMaybe<Scalars['String']>;
};

export type Deal = {
  __typename?: 'Deal';
  appointment?: Maybe<Appointment>;
  attributes?: Maybe<DealAttributes>;
  brand: Scalars['String'];
  car: DealCustomizedCarConfiguration;
  country: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  customer?: Maybe<Customer>;
  dealer?: Maybe<Dealer>;
  /** @deprecated Use disabledReasons */
  disabled?: Maybe<DisabledDeal>;
  disabledReasons?: Maybe<Array<DisabledDeal>>;
  exportCount?: Maybe<Scalars['Int']>;
  expressionsOfInterest: Array<ExpressionOfInterest>;
  finance?: Maybe<DealFinance>;
  financeApplication?: Maybe<FinanceApplication>;
  insurance?: Maybe<DealInsurance>;
  journeyType: JourneyType;
  language: Scalars['String'];
  location?: Maybe<Location>;
  paymentInfo: Array<Maybe<PaymentInfo>>;
  region: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['String'];
  uuid: Scalars['String'];
};

export type DealAttributes = {
  __typename?: 'DealAttributes';
  co2?: Maybe<Scalars['Int']>;
  governmentEvRebate?: Maybe<Scalars['Float']>;
  isDistributionStock?: Maybe<Scalars['Boolean']>;
  market?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['Int']>;
  paymentFee?: Maybe<PaymentFee>;
  range?: Maybe<Scalars['Int']>;
  /** @deprecated Use `paymentFee`. */
  reservationBalance?: Maybe<ReservationBalance>;
  salesEnablement?: Maybe<SalesEnablementDealAttributes>;
  showErrorModal?: Maybe<Scalars['Boolean']>;
  totalPurchaseAmount?: Maybe<Scalars['Float']>;
  tradeIn?: Maybe<Scalars['Boolean']>;
  tradeInColour?: Maybe<Scalars['String']>;
  tradeInComment?: Maybe<Scalars['String']>;
  tradeInMake?: Maybe<Scalars['String']>;
  tradeInMileage?: Maybe<Scalars['String']>;
  tradeInModel?: Maybe<Scalars['String']>;
  tradeInRegistrationNumber?: Maybe<Scalars['String']>;
  tradeInVariant?: Maybe<Scalars['String']>;
  tradeInYear?: Maybe<Scalars['String']>;
  vehicleDetailsPageUrl?: Maybe<Scalars['String']>;
};

export type DealCarPrice = {
  __typename?: 'DealCarPrice';
  finalPrice: Array<Price>;
  offers?: Maybe<Offers>;
  originalPrice: Array<Price>;
  totalDiscount: Array<Money>;
};

export type DealConnection = {
  __typename?: 'DealConnection';
  edges: Array<Maybe<DealEdge>>;
  pageInfo: PageInfoData;
};

export type DealCustomizedCarConfiguration = {
  __typename?: 'DealCustomizedCarConfiguration';
  aggregatedOptions?: Maybe<Scalars['String']>;
  attributes?: Maybe<CarAttributes>;
  background?: Maybe<Background>;
  bodyStyle?: Maybe<BodyStyle>;
  code: Scalars['String'];
  configurationSourceUrl: Scalars['String'];
  deliveryTimeFrame?: Maybe<DeliveryTimeFrame>;
  disclaimers?: Maybe<Array<Disclaimer>>;
  displayName?: Maybe<Scalars['String']>;
  engine?: Maybe<Engine>;
  exterior?: Maybe<Exterior>;
  images?: Maybe<Array<Image>>;
  interior?: Maybe<Interior>;
  isForReservation?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Model>;
  nameplate?: Maybe<Nameplate>;
  prices?: Maybe<DealPrices>;
  selectedFeatures?: Maybe<Array<DealFeature>>;
  specPack?: Maybe<SpecPack>;
  standardFeatures?: Maybe<Array<DealFeature>>;
  startConfigurationSourceUrl?: Maybe<Scalars['String']>;
  stock?: Maybe<DealStock>;
  variant?: Maybe<Variant>;
};

export type DealEdge = {
  __typename?: 'DealEdge';
  cursor: Scalars['String'];
  node: Deal;
};

export type DealFeature = {
  __typename?: 'DealFeature';
  attributes?: Maybe<DealFeatureAttributes>;
  categoryCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Array<Maybe<Image>>>;
  prices?: Maybe<Array<Price>>;
  shortname: Scalars['String'];
};

export type DealFeatureAttributes = {
  __typename?: 'DealFeatureAttributes';
  childrenDetails: Array<ExtraFeature>;
};

export type DealFinance = {
  __typename?: 'DealFinance';
  /** @deprecated Breakdown is not saved as schema */
  breakdown?: Maybe<FinanceBreakdownJsonSchema>;
  breakdownBlocks?: Maybe<Array<BreakdownBlock>>;
  disclaimers?: Maybe<Array<FinanceInfoDisclaimer>>;
  formInput?: Maybe<FormInput>;
  simulation?: Maybe<DealFinanceSimulation>;
  type?: Maybe<Scalars['String']>;
};

export type DealFinanceAttributes = {
  __typename?: 'DealFinanceAttributes';
  balloonAmountPercentage?: Maybe<Scalars['String']>;
  cae?: Maybe<Scalars['String']>;
  calculatorNetPrice?: Maybe<Scalars['String']>;
  depositAmountPercentage?: Maybe<Scalars['Int']>;
  establishmentFee?: Maybe<Array<Maybe<FinanceValue>>>;
  residualAmount?: Maybe<Array<Maybe<FinanceValue>>>;
  residualAmountPercentage?: Maybe<Scalars['String']>;
  upfrontFees?: Maybe<Array<Maybe<FinanceValue>>>;
};

export type DealFinanceSimulation = {
  __typename?: 'DealFinanceSimulation';
  /** @deprecated Renamed as incorrectly named. Use totalAmountPayable. */
  amountFinanced?: Maybe<Array<Money>>;
  amountPayable?: Maybe<Array<Money>>;
  attributes?: Maybe<DealFinanceAttributes>;
  comparisonRate?: Maybe<Scalars['Float']>;
  deposit: Array<Money>;
  expiresAt?: Maybe<Scalars['String']>;
  financePackageId?: Maybe<Scalars['String']>;
  financeProductId?: Maybe<Scalars['String']>;
  financeProductName?: Maybe<Scalars['String']>;
  frequency: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  loanTermPeriod: LoanTermPeriod;
  oneForOne?: Maybe<Scalars['Boolean']>;
  paymentValue?: Maybe<Array<Money>>;
  roadCosts?: Maybe<Scalars['String']>;
  totalAmountPayable?: Maybe<Array<Money>>;
};

export type DealInsurance = {
  __typename?: 'DealInsurance';
  applicationAmended?: Maybe<Scalars['Boolean']>;
  applicationDate?: Maybe<Scalars['String']>;
  applicationStatus?: Maybe<Scalars['String']>;
  input?: Maybe<InsuranceInput>;
  policy?: Maybe<Array<Maybe<InsurancePolicy>>>;
};

export type DealPrices = {
  __typename?: 'DealPrices';
  carPrice?: Maybe<DealCarPrice>;
  discounts: Array<Discount>;
  totalConfiguration: Array<Price>;
  totalFeatures: Array<Price>;
  totalNonFinanceableFeatures?: Maybe<Array<Price>>;
  totalOfferFeatures?: Maybe<Array<Price>>;
  totalPrice: Array<Price>;
  type: Scalars['String'];
};

export type DealResult = {
  __typename?: 'DealResult';
  deal: Deal;
  /** @deprecated Use the one inside the Deal query */
  disabled?: Maybe<DisabledDeal>;
};

export type DealStock = {
  __typename?: 'DealStock';
  attributes?: Maybe<Scalars['String']>;
  dms?: Maybe<Scalars['String']>;
  stockType?: Maybe<StockType>;
  vin?: Maybe<Scalars['String']>;
};

export enum DealTypes {
  Enquiries = 'enquiries',
  Orders = 'orders',
  Reservations = 'reservations',
  SavedCars = 'savedCars'
}

export type DealWithQuote = {
  __typename?: 'DealWithQuote';
  appointment?: Maybe<Appointment>;
  attributes: DealAttributes;
  brand: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  customer?: Maybe<Customer>;
  dealer?: Maybe<Dealer>;
  disabledReasons?: Maybe<Array<DisabledDeal>>;
  expressionsOfInterest: Array<ExpressionOfInterest>;
  financeApplication?: Maybe<FinanceApplication>;
  journeyType: JourneyType;
  language: Scalars['String'];
  location?: Maybe<Location>;
  paymentInfo: Array<Maybe<PaymentInfo>>;
  quote: Quote;
  region: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['String'];
  uuid: Scalars['String'];
};

export type DealWithQuoteConnection = {
  __typename?: 'DealWithQuoteConnection';
  edges: Array<Maybe<DealWithQuoteEdge>>;
  pageInfo: PageInfoData;
};

export type DealWithQuoteEdge = {
  __typename?: 'DealWithQuoteEdge';
  cursor: Scalars['String'];
  node: DealWithQuote;
};

export type DealWithQuoteResult = {
  __typename?: 'DealWithQuoteResult';
  deal?: Maybe<DealWithQuote>;
  error?: Maybe<QuoteError>;
};

export type Dealer = {
  __typename?: 'Dealer';
  address?: Maybe<DealerAddress>;
  attributes?: Maybe<DealerAttributes>;
  consultants?: Maybe<Array<DealerConsultant>>;
  externalId: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postCode: Scalars['String'];
};

export type DealerAddress = {
  __typename?: 'DealerAddress';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  geoLevel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type DealerAttributes = {
  __typename?: 'DealerAttributes';
  paymentMerchantId?: Maybe<Scalars['String']>;
  publicToken?: Maybe<Scalars['String']>;
};

export type DealerConsultant = {
  __typename?: 'DealerConsultant';
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DealersList = {
  __typename?: 'DealersList';
  count?: Maybe<Scalars['Int']>;
  defaultMapLocation?: Maybe<MapLocation>;
  nodes?: Maybe<Array<Dealer>>;
};

export type DefaultMiscellaneousOptionInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['Int'];
  taxable: Scalars['Boolean'];
};

export type DeliveryTimeFrame = {
  __typename?: 'DeliveryTimeFrame';
  deliveryTimeFrameLabel?: Maybe<Scalars['String']>;
};

export type Deposit = {
  __typename?: 'Deposit';
  type: DepositType;
  value: Scalars['Float'];
};

export type DepositCriteria = {
  __typename?: 'DepositCriteria';
  percentageValue: Scalars['Float'];
  value: Money;
};

export enum DepositType {
  Absolute = 'absolute',
  Percentage = 'percentage'
}

export enum DisabledDeal {
  DealExpired = 'dealExpired',
  DealInfoOutOfDate = 'dealInfoOutOfDate',
  DealNotAvailable = 'dealNotAvailable',
  FinanceApplicationExists = 'financeApplicationExists',
  ModifiedByDealer = 'modifiedByDealer'
}

export type Disclaimer = {
  __typename?: 'Disclaimer';
  needsToBeTranslated: Scalars['Boolean'];
  purpose?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  badge: Badge;
  code?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  optionCode?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  value: Array<Money>;
};

export type Engine = {
  __typename?: 'Engine';
  attributes?: Maybe<EngineAttributes>;
  code: Scalars['String'];
  image?: Maybe<Image>;
};

export type EngineAttributes = {
  __typename?: 'EngineAttributes';
  acceleration?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  alternatorcapacity?: Maybe<Scalars['String']>;
  batterycapacity?: Maybe<Scalars['String']>;
  batterynumber?: Maybe<Scalars['String']>;
  bluetank?: Maybe<Scalars['String']>;
  brakingsystemtype?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['String']>;
  cartercapacity?: Maybe<Scalars['String']>;
  cartercapacitydisclaimer?: Maybe<Scalars['String']>;
  chassisweight?: Maybe<Scalars['String']>;
  combfuelcycle?: Maybe<Scalars['Float']>;
  crewnumber?: Maybe<Scalars['String']>;
  cylinder?: Maybe<Scalars['Int']>;
  disclaimer?: Maybe<Scalars['String']>;
  enginepower?: Maybe<Scalars['String']>;
  environmentalstandard?: Maybe<Scalars['String']>;
  environmentalstandarddisclaimer?: Maybe<Scalars['String']>;
  finalshaftratio?: Maybe<Scalars['String']>;
  frontaxlecapacity?: Maybe<Scalars['String']>;
  frontaxleshockabsorber?: Maybe<Scalars['String']>;
  frontaxlesuspensiontype?: Maybe<Scalars['String']>;
  frontsuspensioncapacity?: Maybe<Scalars['String']>;
  fuelLabel?: Maybe<Scalars['String']>;
  fuelType?: Maybe<Scalars['String']>;
  fueleconomy_combinedwltp_co2_tel?: Maybe<Scalars['String']>;
  fueleconomy_nedcequivalent?: Maybe<Scalars['String']>;
  fueleconomy_nedcequivalent_co2?: Maybe<Scalars['String']>;
  fueleconomy_wltpconsumption_teh?: Maybe<Scalars['String']>;
  fueleconomy_wltpconsumption_tel?: Maybe<Scalars['String']>;
  fueltank?: Maybe<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  gearnumbers?: Maybe<Scalars['String']>;
  grosscombinedvehicleweight_c2s1?: Maybe<Scalars['String']>;
  grosscombinedvehicleweight_c2s2?: Maybe<Scalars['String']>;
  grosscombinedvehicleweight_c2s3?: Maybe<Scalars['String']>;
  grossloadcapacity?: Maybe<Scalars['String']>;
  grossvehicleweight?: Maybe<Scalars['String']>;
  grossweightdisclaimer?: Maybe<Scalars['String']>;
  /** @deprecated Use `shortname`. */
  label?: Maybe<Scalars['String']>;
  longdescription?: Maybe<Scalars['String']>;
  maximumpower?: Maybe<Scalars['String']>;
  maximumspeed?: Maybe<Scalars['String']>;
  maximumtorque?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  motor?: Maybe<Scalars['String']>;
  nominalvoltage?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  offroadaxlecapacity?: Maybe<Scalars['String']>;
  possiblefuels?: Maybe<Scalars['String']>;
  powersystem?: Maybe<Scalars['String']>;
  powertrain?: Maybe<Scalars['String']>;
  propulsion?: Maybe<Scalars['String']>;
  rearaxlecapacity?: Maybe<Scalars['String']>;
  rearaxleshockabsorber?: Maybe<Scalars['String']>;
  rearaxlesuspensiontype?: Maybe<Scalars['String']>;
  rearsuspensioncapacity?: Maybe<Scalars['String']>;
  relationship1?: Maybe<Scalars['String']>;
  relationship2?: Maybe<Scalars['String']>;
  relationship3?: Maybe<Scalars['String']>;
  relationship4?: Maybe<Scalars['String']>;
  relationship5?: Maybe<Scalars['String']>;
  relationship6?: Maybe<Scalars['String']>;
  relationship7?: Maybe<Scalars['String']>;
  relationship8?: Maybe<Scalars['String']>;
  relationship9?: Maybe<Scalars['String']>;
  relationship10?: Maybe<Scalars['String']>;
  relationship11?: Maybe<Scalars['String']>;
  reverse?: Maybe<Scalars['String']>;
  reverse1?: Maybe<Scalars['String']>;
  reverse2?: Maybe<Scalars['String']>;
  reverse3?: Maybe<Scalars['String']>;
  shortdescription?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
  slopestartingcapability?: Maybe<Scalars['String']>;
  tankcapacity?: Maybe<Scalars['String']>;
  tireturningradius?: Maybe<Scalars['String']>;
  traction?: Maybe<Scalars['String']>;
  tranmissioncategorised?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  transmissionLabel?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  transmissioncategorised?: Maybe<Scalars['String']>;
  transmissionreference?: Maybe<Scalars['String']>;
};

export type EngineResult = {
  __typename?: 'EngineResult';
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  engine: Engine;
  financeFormInput?: Maybe<FinanceFormInputData>;
  nextFilters?: Maybe<ResponseFilters>;
  quoteResult: QuoteResult;
};


export type EngineResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type EnquiryFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type EwayPaymentResponse = Payment & {
  __typename?: 'EwayPaymentResponse';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  verifyUrl?: Maybe<Scalars['String']>;
};

export type ExpressionOfInterest = {
  __typename?: 'ExpressionOfInterest';
  attributes?: Maybe<ExpressionOfInterestData>;
  code: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ExpressionOfInterestData = {
  __typename?: 'ExpressionOfInterestData';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  picture: Scalars['String'];
};

export type Exterior = {
  __typename?: 'Exterior';
  attributes?: Maybe<ExteriorAttributes>;
  categoryCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  image?: Maybe<Array<Maybe<Image>>>;
  price?: Maybe<Price>;
  shortname: Scalars['String'];
};

export type ExteriorAttributes = {
  __typename?: 'ExteriorAttributes';
  oemcode: Scalars['String'];
};

export type ExtraFeature = {
  __typename?: 'ExtraFeature';
  attributes?: Maybe<ExtraFeatureAttributes>;
  categoryCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  images: Array<Image>;
  longDescription?: Maybe<Scalars['String']>;
  parentCategoryCode?: Maybe<Scalars['String']>;
  prices: Array<Price>;
  shortDescription?: Maybe<Scalars['String']>;
  shortname: Scalars['String'];
};

export type ExtraFeatureAttributes = {
  __typename?: 'ExtraFeatureAttributes';
  addondescriptiontext?: Maybe<Scalars['String']>;
  addondescriptiontitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  detailPictureLink?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
  externalSku?: Maybe<Scalars['String']>;
  extradetails?: Maybe<Scalars['String']>;
  hexColourCode?: Maybe<Scalars['String']>;
  isDefaultItem?: Maybe<Scalars['Boolean']>;
  longdescription?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  salespersonViewOnly?: Maybe<Scalars['Boolean']>;
  serviceIntervals?: Maybe<Array<Maybe<ServiceInterval>>>;
  shortname?: Maybe<Scalars['String']>;
  type?: Maybe<FeatureType>;
  viewmore?: Maybe<Scalars['Boolean']>;
};

export type ExtraFeatureCategories = {
  __typename?: 'ExtraFeatureCategories';
  attributes?: Maybe<ExtraFeatureCategoryAttributes>;
  code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  parentCategoryCode?: Maybe<Scalars['String']>;
  shortname: Scalars['String'];
};

export type ExtraFeatureCategoryAttributes = {
  __typename?: 'ExtraFeatureCategoryAttributes';
  brand?: Maybe<Scalars['String']>;
  categorypurpose?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disclaimerindicative?: Maybe<Scalars['String']>;
  displaycount?: Maybe<Scalars['Boolean']>;
  displayfeaturename?: Maybe<Scalars['Boolean']>;
  displayfeatureprice?: Maybe<Scalars['Boolean']>;
  displaylabelofselectedoptiononcategory?: Maybe<Scalars['Boolean']>;
  displaymode?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
  imagePov?: Maybe<Scalars['String']>;
  keyfeaturec?: Maybe<Scalars['Boolean']>;
  numberofitemsperrow?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  selectiontype?: Maybe<FeatureType>;
  viewnumberoffeatures?: Maybe<Scalars['String']>;
};

export enum FacetOptionStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Selected = 'SELECTED'
}

export type Feature = {
  __typename?: 'Feature';
  attributes?: Maybe<FeatureAttributes>;
  categoryCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  images: Array<Image>;
  /** @deprecated Use `shortname instead`. */
  label: Scalars['String'];
  longDescription?: Maybe<Scalars['String']>;
  parentCategoryCode?: Maybe<Scalars['String']>;
  prices: Array<Price>;
  shortDescription?: Maybe<Scalars['String']>;
  shortname: Scalars['String'];
};

export type FeatureAttributes = {
  __typename?: 'FeatureAttributes';
  addondescriptiontext?: Maybe<Scalars['String']>;
  addondescriptiontitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  detailPictureLink?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
  externalSku?: Maybe<Scalars['String']>;
  extradetails?: Maybe<Scalars['String']>;
  hexColourCode?: Maybe<Scalars['String']>;
  isDefaultItem?: Maybe<Scalars['Boolean']>;
  longdescription?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  salespersonViewOnly?: Maybe<Scalars['Boolean']>;
  serviceIntervals?: Maybe<Array<Maybe<ServiceInterval>>>;
  shortname?: Maybe<Scalars['String']>;
  type?: Maybe<FeatureType>;
  viewmore?: Maybe<Scalars['Boolean']>;
};

export type FeatureCategory = {
  __typename?: 'FeatureCategory';
  attributes?: Maybe<FeatureCategoryAttributes>;
  code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  /** @deprecated Use `shortname instead`. */
  label: Scalars['String'];
  parentCategoryCode?: Maybe<Scalars['String']>;
  shortname: Scalars['String'];
};

export type FeatureCategoryAttributes = {
  __typename?: 'FeatureCategoryAttributes';
  brand?: Maybe<Scalars['String']>;
  categorypurpose?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disclaimerindicative?: Maybe<Scalars['String']>;
  displaycount?: Maybe<Scalars['Boolean']>;
  displayfeaturename?: Maybe<Scalars['Boolean']>;
  displayfeatureprice?: Maybe<Scalars['Boolean']>;
  displaylabelofselectedoptiononcategory?: Maybe<Scalars['Boolean']>;
  displaymode?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
  imagePov?: Maybe<Scalars['String']>;
  keyfeaturec?: Maybe<Scalars['Boolean']>;
  numberofitemsperrow?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  selectiontype?: Maybe<FeatureType>;
  viewnumberoffeatures?: Maybe<Scalars['String']>;
};

export type FeatureCodes = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FeatureGroup = {
  __typename?: 'FeatureGroup';
  featureItems?: Maybe<Array<Maybe<FeatureItem>>>;
  name?: Maybe<Scalars['String']>;
};

export type FeatureIdsInput = {
  added?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  included?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  removed?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FeatureItem = {
  __typename?: 'FeatureItem';
  disclaimer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FeatureSection = {
  __typename?: 'FeatureSection';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export enum FeatureType {
  Multi = 'multi',
  Mutex0 = 'mutex0',
  Mutex1 = 'mutex1'
}

export type Filters = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  engineCode?: InputMaybe<Scalars['String']>;
  modelCode?: InputMaybe<Scalars['String']>;
  specPackCode?: InputMaybe<Scalars['String']>;
  trimCode: Scalars['TrimCode'];
  variantCode?: InputMaybe<Scalars['String']>;
};

export type Finance = {
  __typename?: 'Finance';
  breakdown: FinanceBreakdownJsonSchema;
  /** @deprecated Use updateForm() */
  cashForm: FinanceBreakdownJsonSchema;
  loadForm: FinanceBreakdownJsonSchema;
  simulationInfo: Array<FinanceResultWithDisclaimers>;
  updateForm: FinanceBreakdownJsonSchema;
};


export type FinanceBreakdownArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  selectedCar: SelectedCar;
};


export type FinanceCashFormArgs = {
  selectedCar: SelectedCar;
};


export type FinanceLoadFormArgs = {
  externalSite?: InputMaybe<Scalars['Boolean']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  selectedCar: SelectedCar;
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};


export type FinanceSimulationInfoArgs = {
  codes: Array<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};


export type FinanceUpdateFormArgs = {
  externalSite?: InputMaybe<Scalars['Boolean']>;
  financeFormInput: FinanceFormInput;
  selectedCar: SelectedCar;
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};

export type FinanceApplication = {
  __typename?: 'FinanceApplication';
  alliedOnlineApplicationUrl?: Maybe<Scalars['String']>;
  callbackRequested?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  disclaimers: Array<FinanceInfoDisclaimer>;
  finance?: Maybe<FinanceApplicationFinance>;
  financeApplicationJourney?: Maybe<FinanceApplicationJourney>;
  lender?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionId?: Maybe<Scalars['String']>;
};

export type FinanceApplicationDetails = {
  __typename?: 'FinanceApplicationDetails';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FinanceApplicationFinance = {
  __typename?: 'FinanceApplicationFinance';
  formInput?: Maybe<FinanceFormInputData>;
  simulation?: Maybe<DealFinanceSimulation>;
};

export type FinanceApplicationForm = {
  __typename?: 'FinanceApplicationForm';
  details?: Maybe<Array<FinanceApplicationDetails>>;
  form: JsonForm;
};

export type FinanceApplicationFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export enum FinanceApplicationJourney {
  Default = 'DEFAULT',
  OnlineApplication = 'ONLINE_APPLICATION',
  RequestQuote = 'REQUEST_QUOTE'
}

export type FinanceBreakdownJsonSchema = {
  __typename?: 'FinanceBreakdownJsonSchema';
  schema: Scalars['String'];
  simulation?: Maybe<FinanceResult>;
};

export type FinanceCalculatorForm = {
  __typename?: 'FinanceCalculatorForm';
  formData: Scalars['String'];
  schema: Scalars['String'];
  uiSchema: Scalars['String'];
};

export type FinanceCalculatorFormResponse = {
  __typename?: 'FinanceCalculatorFormResponse';
  breakdown: Array<BreakdownBlock>;
  disclaimers: Array<FinanceInfoDisclaimer>;
  financeResult: FinanceResult;
  form: FinanceCalculatorForm;
  header: FinanceCalculatorHeader;
  offersFinanceBreakdown: Array<OffersFinanceBreakdownBlock>;
  repaymentSection?: Maybe<RepaymentSection>;
  /** @deprecated Use quote */
  simulation: FinanceResult;
  totalDepositSection?: Maybe<TotalDepositSection>;
  tradeIn?: Maybe<TradeInResult>;
};

export type FinanceCalculatorHeader = {
  __typename?: 'FinanceCalculatorHeader';
  headerPrices: Array<HeaderPrice>;
  vehicleDisplayName: Scalars['String'];
};

export type FinanceCriteria = {
  __typename?: 'FinanceCriteria';
  ageRange?: Maybe<AgeRange>;
  deposits: Array<DepositCriteria>;
  financeProduct: FinanceProduct;
  homeOwner?: Maybe<HomeOwner>;
  interestRate?: Maybe<InterestRate>;
  mileage?: Maybe<Mileage>;
  paymentFrequency: PaymentFrequency;
  residualValue?: Maybe<ResidualValue>;
  term: Term;
};

export type FinanceForm = {
  __typename?: 'FinanceForm';
  loadForm: FinanceCalculatorFormResponse;
  loadFormFromQuote: FinanceCalculatorFormResponse;
  updateForm: FinanceCalculatorFormResponse;
  updateFormFromQuote: FinanceCalculatorFormResponse;
};


export type FinanceFormLoadFormArgs = {
  externalSite?: InputMaybe<Scalars['Boolean']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  selectedCar: SelectedCar;
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};


export type FinanceFormLoadFormFromQuoteArgs = {
  quoteId: Scalars['String'];
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};


export type FinanceFormUpdateFormArgs = {
  externalSite?: InputMaybe<Scalars['Boolean']>;
  financeFormInput: FinanceFormInput;
  selectedCar: SelectedCar;
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};


export type FinanceFormUpdateFormFromQuoteArgs = {
  financeFormInput: FinanceFormInput;
  postCode?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['String'];
  tradeInEquity?: InputMaybe<Scalars['Float']>;
};

export enum FinanceFormCustomerType {
  Business = 'business',
  Private = 'private'
}

export type FinanceFormInput = {
  ageRange?: InputMaybe<Scalars['String']>;
  creditRating?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<FinanceFormCustomerType>;
  deposit?: InputMaybe<Scalars['Float']>;
  financePackageId?: InputMaybe<Scalars['String']>;
  financeProductId?: InputMaybe<Scalars['String']>;
  homeOwner?: InputMaybe<Scalars['String']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  mileage?: InputMaybe<Scalars['Int']>;
  monthlyPaymentRange?: InputMaybe<MonthlyPaymentRange>;
  partExchangeId?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<Scalars['String']>;
  paymentType: FinanceFormType;
  residualValue?: InputMaybe<Scalars['Float']>;
  term?: InputMaybe<Scalars['Int']>;
};

export type FinanceFormInputData = {
  __typename?: 'FinanceFormInputData';
  ageRange?: Maybe<Scalars['String']>;
  customerType?: Maybe<FinanceFormCustomerType>;
  deposit?: Maybe<Scalars['Float']>;
  financePackageId?: Maybe<Scalars['String']>;
  financeProductId?: Maybe<Scalars['String']>;
  homeOwner?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  mileage?: Maybe<Scalars['Int']>;
  partExchangeId?: Maybe<Scalars['String']>;
  paymentType: FinanceFormType;
  residualValue?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
};

export enum FinanceFormType {
  Cash = 'cash',
  Finance = 'finance'
}

export type FinanceInfoDisclaimer = {
  __typename?: 'FinanceInfoDisclaimer';
  purpose: Scalars['String'];
  value: Scalars['String'];
};

export type FinanceInput = {
  financeProductId?: InputMaybe<Scalars['String']>;
  journeyType: FinanceFormType;
  term?: InputMaybe<Scalars['Int']>;
};

export type FinanceProduct = {
  __typename?: 'FinanceProduct';
  displayLabel: Scalars['String'];
  id: Scalars['String'];
};

export type FinanceQuote = {
  __typename?: 'FinanceQuote';
  criteria: FinanceCriteria;
  simulation: Simulation;
};

export type FinanceResult = {
  __typename?: 'FinanceResult';
  disclaimers: Array<Disclaimer>;
  editText?: Maybe<Scalars['String']>;
  quote?: Maybe<FinanceQuote>;
  /** @deprecated Use quote */
  simulation?: Maybe<FinanceSimulation>;
  type: FinanceResultType;
};

export enum FinanceResultType {
  Cash = 'cash',
  Error = 'error',
  Finance = 'finance',
  Na = 'na',
  NotApplicable = 'not_applicable'
}

export type FinanceResultWithDisclaimers = {
  __typename?: 'FinanceResultWithDisclaimers';
  disclaimers: Array<FinanceInfoDisclaimer>;
  postCode?: Maybe<Scalars['String']>;
  result: FinanceResult;
};

export type FinanceSimulation = {
  __typename?: 'FinanceSimulation';
  cae?: Maybe<Scalars['Float']>;
  comparisonRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use `deposits`. */
  deposit?: Maybe<Deposit>;
  deposits?: Maybe<Array<Maybe<Deposit>>>;
  financeAmount: Array<FinanceValue>;
  financePackageId?: Maybe<Scalars['String']>;
  financeProduct?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  loanTermPeriod?: Maybe<LoanTermPeriod>;
  mileage?: Maybe<Scalars['Int']>;
  oneForOne?: Maybe<Scalars['Boolean']>;
  outOfRange?: Maybe<Scalars['Boolean']>;
  paymentValue?: Maybe<Array<FinanceValue>>;
  residualValue?: Maybe<FinanceValue>;
};

export type FinanceValue = {
  __typename?: 'FinanceValue';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type FormInput = {
  __typename?: 'FormInput';
  customerType?: Maybe<FinanceFormCustomerType>;
  deposit?: Maybe<Scalars['Float']>;
  financePackageId?: Maybe<Scalars['String']>;
  financeProductId?: Maybe<Scalars['String']>;
  homeOwner?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  mileage?: Maybe<Scalars['Int']>;
  paymentType: FinanceFormType;
  term?: Maybe<Scalars['Int']>;
};

export type Freebies = {
  __typename?: 'Freebies';
  code?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type FullStockCar = StockCar & {
  __typename?: 'FullStockCar';
  carId: Scalars['CarId'];
  carMatchLabel: Scalars['String'];
  /** @deprecated Use `prices` instead. */
  carPrice: CarPrice;
  disclaimer?: Maybe<Disclaimer>;
  finance: FinanceResult;
  images: Array<Image>;
  keyFeatures: Array<Feature>;
  /** @deprecated Use quote.prices instead */
  prices: Prices;
  quote: QuoteMinimal;
  selectedFeatures: SelectedFeatures;
  vin?: Maybe<Scalars['String']>;
};


export type FullStockCarDisclaimerArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};


export type FullStockCarFinanceArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type FullStockCarQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};

export type GovernmentEvRebate = {
  __typename?: 'GovernmentEvRebate';
  label: Scalars['String'];
  value?: Maybe<Money>;
};

export type HeaderPrice = {
  __typename?: 'HeaderPrice';
  label: Scalars['String'];
  priceType: PriceTypes;
  tooltipText: Scalars['String'];
  tooltipTitle: Scalars['String'];
  value: Money;
};

export type HomeOwner = {
  __typename?: 'HomeOwner';
  value: Scalars['Boolean'];
};

export type IscSession = {
  __typename?: 'ISCSession';
  id: Scalars['String'];
  isSalesAdmin: Scalars['Boolean'];
};

export type Image = {
  __typename?: 'Image';
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InStoreCapabilityMutation = {
  __typename?: 'InStoreCapabilityMutation';
  logout?: Maybe<Scalars['Boolean']>;
  releaseStockLock?: Maybe<Scalars['Boolean']>;
  saveInStoreDeal: Deal;
};


export type InStoreCapabilityMutationSaveInStoreDealArgs = {
  dealerId?: InputMaybe<Scalars['String']>;
  journeyType?: InputMaybe<JourneyType>;
  selectedCar?: InputMaybe<SelectedCarForDeal>;
};

export type InStoreCapabilityQuery = {
  __typename?: 'InStoreCapabilityQuery';
  getInStoreSession?: Maybe<IscSession>;
  getStockInfo?: Maybe<ByoCarAttributes>;
};

export type InStorePayment = {
  __typename?: 'InStorePayment';
  description?: Maybe<Scalars['String']>;
  details?: Maybe<InStorePaymentDetails>;
  referencedCode?: Maybe<Scalars['String']>;
};

export type InStorePaymentAttributes = {
  __typename?: 'InStorePaymentAttributes';
  inStoreDatePaid?: Maybe<Scalars['String']>;
  inStoreDescription?: Maybe<Scalars['String']>;
  inStorePaymentAmount?: Maybe<Scalars['Int']>;
  inStoreReferenceNumber?: Maybe<Scalars['String']>;
};

export type InStorePaymentDetails = {
  __typename?: 'InStorePaymentDetails';
  inStorePayment?: Maybe<InStorePaymentAttributes>;
};

export type Insurance = {
  __typename?: 'Insurance';
  loadApplicationForm: InsuranceJsonSchema;
  loadEstimationForm: InsuranceJsonSchema;
  updateEstimationForm: InsuranceJsonSchema;
  validateApplicationForm: Scalars['String'];
};


export type InsuranceLoadApplicationFormArgs = {
  dealId: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type InsuranceLoadEstimationFormArgs = {
  carCode: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
};


export type InsuranceUpdateEstimationFormArgs = {
  carCode: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type InsuranceValidateApplicationFormArgs = {
  dealId: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};

export type InsuranceEstimation = {
  __typename?: 'InsuranceEstimation';
  age?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  noClaimsDiscount?: Maybe<Scalars['String']>;
  policy: Array<InsurancePolicy>;
};

export type InsuranceFormInput = {
  formData: Scalars['String'];
};

export type InsuranceInput = {
  __typename?: 'InsuranceInput';
  dateOfBirth?: Maybe<Scalars['String']>;
  estimate: Scalars['Boolean'];
  noClaimsDiscount: Scalars['String'];
};

export type InsuranceJsonSchema = {
  __typename?: 'InsuranceJsonSchema';
  formData: Scalars['String'];
  schema: Scalars['String'];
  uiSchema: Scalars['String'];
};

export type InsuranceMutation = {
  __typename?: 'InsuranceMutation';
  submitApplicationForm: InsuranceJsonSchema;
};


export type InsuranceMutationSubmitApplicationFormArgs = {
  dealId: Scalars['String'];
  identityVerificationState?: InputMaybe<Scalars['String']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  money: Money;
  type: Scalars['String'];
};

export type InsuranceResult = {
  __typename?: 'InsuranceResult';
  displayBlock: Scalars['Boolean'];
  estimation?: Maybe<InsuranceEstimation>;
};

export type InterestRate = {
  __typename?: 'InterestRate';
  value: Scalars['Float'];
};

export type Interior = {
  __typename?: 'Interior';
  attributes?: Maybe<InteriorAttributes>;
  categoryCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  image?: Maybe<Array<Maybe<Image>>>;
  price?: Maybe<Price>;
  shortname: Scalars['String'];
};

export type InteriorAttributes = {
  __typename?: 'InteriorAttributes';
  oemcode: Scalars['String'];
};

export type JlrPolandMiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'JLRPolandMiscellaneousOptionDefinition';
  category: Scalars['String'];
  categoryName: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  descriptionEditable: Scalars['Boolean'];
  price: Money;
  priceEditable: Scalars['Boolean'];
};

export type JlrPolandMiscellaneousOptionInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['Int'];
};

export enum JourneyType {
  ContinueInDealership = 'continue_in_dealership',
  OnlineOrder = 'online_order',
  PreOrderNow = 'pre_order_now',
  ReserveOnline = 'reserve_online',
  SaveMyBuild = 'save_my_build'
}

export type JsonForm = {
  __typename?: 'JsonForm';
  formData?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  uiSchema?: Maybe<Scalars['String']>;
};

export type ListExtraAccessories = {
  __typename?: 'ListExtraAccessories';
  extraFeatureCategories?: Maybe<Array<ExtraFeatureCategories>>;
  extraFeatures?: Maybe<Array<ExtraFeature>>;
};

export type LoanTermPeriod = {
  __typename?: 'LoanTermPeriod';
  unit?: Maybe<LoanTermPeriodUnit>;
  value?: Maybe<Scalars['Int']>;
};

export enum LoanTermPeriodUnit {
  Month = 'month'
}

export type Location = {
  __typename?: 'Location';
  district?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type MapLocation = {
  __typename?: 'MapLocation';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type MercadoPagoPaymentResponse = Payment & {
  __typename?: 'MercadoPagoPaymentResponse';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type MercedesPhMiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'MercedesPHMiscellaneousOptionDefinition';
  category: Scalars['String'];
  categoryName: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  descriptionEditable: Scalars['Boolean'];
  price: Money;
  priceEditable: Scalars['Boolean'];
};

export type MercedesPhMiscellaneousOptionInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['Int'];
};

export type MergedFeatures = {
  __typename?: 'MergedFeatures';
  into?: Maybe<Scalars['String']>;
  merged: Array<Maybe<Scalars['String']>>;
};

export type Mileage = {
  __typename?: 'Mileage';
  value: Scalars['Int'];
};

export type MiscellaneousOption = {
  __typename?: 'MiscellaneousOption';
  category?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description: Scalars['String'];
  gst?: Maybe<Scalars['Int']>;
  gstExempt?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  taxable: Scalars['Boolean'];
  total?: Maybe<Scalars['Int']>;
};

export type MiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'MiscellaneousOptionDefinition';
  code: Scalars['String'];
  description: Scalars['String'];
};

export type MiscellaneousOptionDefinitionResult = {
  code: Scalars['String'];
  description: Scalars['String'];
};

export type MiscellaneousOptionInput = {
  complexInput?: InputMaybe<Array<ComplexMiscellaneousOptionInput>>;
  defaultInput?: InputMaybe<Array<DefaultMiscellaneousOptionInput>>;
  inputType: MiscellaneousOptionTypes;
  jlrPolandInput?: InputMaybe<Array<JlrPolandMiscellaneousOptionInput>>;
  mercedesPhInput?: InputMaybe<Array<MercedesPhMiscellaneousOptionInput>>;
  simpleInput?: InputMaybe<Array<SimpleMiscellaneousOptionInput>>;
  subaruAuInput?: InputMaybe<Array<SubaruAuMiscellaneousOptionInput>>;
};

export enum MiscellaneousOptionTypes {
  ComplexInput = 'complexInput',
  DefaultInput = 'defaultInput',
  JlrPolandInput = 'jlrPolandInput',
  MercedesPhInput = 'mercedesPhInput',
  SimpleInput = 'simpleInput',
  SubaruAuInput = 'subaruAuInput'
}

export type Model = {
  __typename?: 'Model';
  attributes?: Maybe<ModelAttributes>;
  code: Scalars['String'];
  image?: Maybe<Image>;
  interiorimage?: Maybe<Image>;
  rearimage?: Maybe<Image>;
  sideimage?: Maybe<Image>;
};

export type ModelAttributes = {
  __typename?: 'ModelAttributes';
  address?: Maybe<Scalars['String']>;
  airconditioning?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  cabin?: Maybe<Scalars['String']>;
  coolanttemperature?: Maybe<Scalars['String']>;
  differentiallock?: Maybe<Scalars['String']>;
  dimensionsFrontwheeltrackFilterLabel?: Maybe<Scalars['String']>;
  dimensions_frontwheeltrack?: Maybe<Scalars['String']>;
  dimensions_frontwheeltrack_filter?: Maybe<Scalars['String']>;
  dimensions_height?: Maybe<Scalars['String']>;
  dimensions_length?: Maybe<Scalars['String']>;
  dimensions_rearwheeltrack?: Maybe<Scalars['String']>;
  dimensions_wheelbase?: Maybe<Scalars['String']>;
  dimensions_width_mirrorsout?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  distancebetweenaxlesdisclaimer?: Maybe<Scalars['String']>;
  doorbrake?: Maybe<Scalars['String']>;
  electromagnetic_retarder?: Maybe<Scalars['String']>;
  explorers?: Maybe<Scalars['String']>;
  fifthwheel?: Maybe<Scalars['String']>;
  foldingchairs?: Maybe<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  grossweightcapacityFilterLabel?: Maybe<Scalars['String']>;
  grossweightcapacity_filter?: Maybe<Scalars['String']>;
  grossweightcapacity_kg?: Maybe<Scalars['String']>;
  hillstartsystem?: Maybe<Scalars['String']>;
  hourmeter?: Maybe<Scalars['String']>;
  idlestop?: Maybe<Scalars['String']>;
  idlestopdisclaimer?: Maybe<Scalars['String']>;
  /** @deprecated Use `shortname`. */
  label: Scalars['String'];
  loadspace_lengthbehindfirstrow?: Maybe<Scalars['String']>;
  longdescription?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  radio?: Maybe<Scalars['String']>;
  rearaxledistance?: Maybe<Scalars['String']>;
  reversealarm?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
  slopeassist?: Maybe<Scalars['String']>;
  sparerim?: Maybe<Scalars['String']>;
  sparetire?: Maybe<Scalars['String']>;
  toolkit?: Maybe<Scalars['String']>;
  usablecabtoaxle?: Maybe<Scalars['String']>;
  usablecabtoaxleFilterLabel?: Maybe<Scalars['String']>;
  usablecabtoaxle_filter?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['String']>;
  wheelsize?: Maybe<Scalars['String']>;
};

export type ModelResult = {
  __typename?: 'ModelResult';
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  financeFormInput?: Maybe<FinanceFormInputData>;
  model: Model;
  nextFilters?: Maybe<ResponseFilters>;
  quoteResult: QuoteResult;
};


export type ModelResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type MonthlyPaymentRange = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type MountedFeature = {
  __typename?: 'MountedFeature';
  code: Scalars['String'];
  image?: Maybe<Array<Maybe<Image>>>;
  shortname: Scalars['String'];
};

export type MountedFeatures = {
  __typename?: 'MountedFeatures';
  exterior: MountedFeature;
  interior?: Maybe<MountedFeature>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authentication: AuthenticationMutation;
  cancelVehicleReservation: Scalars['Boolean'];
  /** @deprecated Use `createDealFromCarId`. */
  createDeal: Deal;
  createDealFromCarId: Deal;
  createDealWithQuote: DealWithQuoteResult;
  createHeadlessDeal: Scalars['String'];
  createJLRDeal: Scalars['String'];
  demoMutation?: Maybe<Scalars['String']>;
  financeApplicationFormSave: FinanceApplication;
  inStoreCapability: InStoreCapabilityMutation;
  /** @deprecated authentication.initForgotPassword */
  initForgotPassword: Scalars['Boolean'];
  initPayment: Payment;
  insurance: InsuranceMutation;
  /** @deprecated authentication.login */
  login: Session;
  myAccount: MyAccountMutation;
  oauth: OAuthMutation;
  register: Customer;
  /** @deprecated authentication.resetPassword */
  resetPassword: Scalars['Boolean'];
  salesEnablement: SalesEnablementMutation;
  saveEnquiryForm: Deal;
  selectCreditOption: FinanceApplication;
  selectDealer?: Maybe<Deal>;
  selectExpressionsOfInterest?: Maybe<Deal>;
  selectJourneyType: Deal;
  /** @deprecated authentication.register */
  setPassword: Scalars['Boolean'];
  startFinanceApplication: FinanceApplication;
  submitFinanceApplication: FinanceApplication;
  updateQuote: QuoteUpdateMutation;
};


export type MutationCancelVehicleReservationArgs = {
  dealId: Scalars['String'];
};


export type MutationCreateDealArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  journeyType: JourneyType;
  postCode?: InputMaybe<Scalars['String']>;
  selectedCar?: InputMaybe<SelectedCarForDeal>;
};


export type MutationCreateDealFromCarIdArgs = {
  dealerId?: InputMaybe<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  journeyType: JourneyType;
  postCode?: InputMaybe<Scalars['String']>;
  selectedCar?: InputMaybe<SelectedCarForDeal>;
  source?: InputMaybe<Scalars['String']>;
  utmDetailsInput?: InputMaybe<UtmDetailsInput>;
};


export type MutationCreateDealWithQuoteArgs = {
  dealerId?: InputMaybe<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  journeyType: JourneyType;
  postCode?: InputMaybe<Scalars['String']>;
  selectedCar?: InputMaybe<SelectedCarForDeal>;
  utmDetailsInput?: InputMaybe<UtmDetailsInput>;
};


export type MutationCreateHeadlessDealArgs = {
  carConfigurationUrl: Scalars['String'];
  checkoutUrl?: InputMaybe<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type MutationCreateJlrDealArgs = {
  carConfigurationUrl: Scalars['String'];
  checkoutUrl?: InputMaybe<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type MutationFinanceApplicationFormSaveArgs = {
  captchaToken?: InputMaybe<Scalars['String']>;
  data: FinanceApplicationFormData;
  stepName?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationInStoreCapabilityArgs = {
  journeyType?: InputMaybe<JourneyType>;
  selectedCar?: InputMaybe<SelectedCarForDeal>;
};


export type MutationInitForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationInitPaymentArgs = {
  identifier: Scalars['String'];
  paymentType: PaymentType;
};


export type MutationLoginArgs = {
  dealId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationRegisterArgs = {
  data: UserDetailsFormData;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveEnquiryFormArgs = {
  captchaToken: Scalars['String'];
  data?: InputMaybe<EnquiryFormData>;
  dealId: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type MutationSelectCreditOptionArgs = {
  dealId: Scalars['String'];
  lenderId?: InputMaybe<Scalars['String']>;
};


export type MutationSelectDealerArgs = {
  dealId: Scalars['String'];
  dealerId: Scalars['String'];
};


export type MutationSelectExpressionsOfInterestArgs = {
  codes: Array<Scalars['String']>;
  dealId: Scalars['String'];
};


export type MutationSelectJourneyTypeArgs = {
  dealId: Scalars['String'];
  journeyType: JourneyType;
};


export type MutationSetPasswordArgs = {
  confirmedPassword: Scalars['String'];
  dealId: Scalars['String'];
  password: Scalars['String'];
};


export type MutationStartFinanceApplicationArgs = {
  dealId: Scalars['String'];
  financeApplicationJourney?: InputMaybe<FinanceApplicationJourney>;
};


export type MutationSubmitFinanceApplicationArgs = {
  dealId: Scalars['String'];
};

export type MyAccountJsonSchemaForm = {
  __typename?: 'MyAccountJsonSchemaForm';
  formData: Scalars['String'];
  schema: Scalars['String'];
  uiSchema: Scalars['String'];
};

export type MyAccountMutation = {
  __typename?: 'MyAccountMutation';
  changePassword: Scalars['Boolean'];
  logout: Scalars['Boolean'];
  removeDeal: Scalars['Boolean'];
  /** @deprecated Use myAccountMutation.removeDeal instead. */
  removeEnquiries: Scalars['Boolean'];
  /** @deprecated Use myAccountMutation.removeDeal instead. */
  removeSavedCar: Scalars['Boolean'];
  updatePersonalDetails: Customer;
};


export type MyAccountMutationChangePasswordArgs = {
  confirmedPassword: Scalars['String'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MyAccountMutationRemoveDealArgs = {
  dealId: Scalars['String'];
};


export type MyAccountMutationRemoveEnquiriesArgs = {
  dealId: Scalars['String'];
};


export type MyAccountMutationRemoveSavedCarArgs = {
  dealId: Scalars['String'];
};


export type MyAccountMutationUpdatePersonalDetailsArgs = {
  data: UserDetailsFormData;
};

export type MyAccountQuery = {
  __typename?: 'MyAccountQuery';
  currentUser: Customer;
  dealWithQuotePage: DealWithQuoteConnection;
  deals: Array<Deal>;
  dealsPage: DealConnection;
  /** @deprecated Use myAccountQuery.deals query instead. */
  enquiries: Array<DealResult>;
  isCurrentPasswordValid: Scalars['Boolean'];
  /** @deprecated Use myAccountQuery.deals query instead. */
  orders: Array<DealResult>;
  /** @deprecated Use myAccountQuery.deals query instead. */
  reservations: Array<DealResult>;
  /** @deprecated Use myAccountQuery.deals query instead. */
  savedCars: Array<DealResult>;
  updatePersonalDetailsForm: JsonForm;
};


export type MyAccountQueryDealWithQuotePageArgs = {
  after?: InputMaybe<Scalars['String']>;
  dealTypes?: InputMaybe<Array<DealTypes>>;
  first: Scalars['Int'];
  withFinance?: InputMaybe<Scalars['Boolean']>;
  withInsurance?: InputMaybe<Scalars['Boolean']>;
};


export type MyAccountQueryDealsArgs = {
  dealTypes?: InputMaybe<Array<DealTypes>>;
  withFinance?: InputMaybe<Scalars['Boolean']>;
  withInsurance?: InputMaybe<Scalars['Boolean']>;
};


export type MyAccountQueryDealsPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  dealTypes?: InputMaybe<Array<DealTypes>>;
  first: Scalars['Int'];
  withFinance?: InputMaybe<Scalars['Boolean']>;
  withInsurance?: InputMaybe<Scalars['Boolean']>;
};


export type MyAccountQueryIsCurrentPasswordValidArgs = {
  currentPassword: Scalars['String'];
};


export type MyAccountQueryOrdersArgs = {
  onlyOrdersWithFinance?: InputMaybe<Scalars['Boolean']>;
  onlyOrdersWithInsurance?: InputMaybe<Scalars['Boolean']>;
};

export enum MyAccountRedirectTarget {
  Login = 'login',
  SetPassword = 'setPassword'
}

export type Nameplate = {
  __typename?: 'Nameplate';
  attributes?: Maybe<NameplateAttributes>;
  code: Scalars['String'];
};

export type NameplateAttributes = {
  __typename?: 'NameplateAttributes';
  brand?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
};

export type OAuthMutation = {
  __typename?: 'OAuthMutation';
  createSession: OauthResponse;
};


export type OAuthMutationCreateSessionArgs = {
  context: OauthContext;
};

export type OAuthQuery = {
  __typename?: 'OAuthQuery';
  getPartialNRIC?: Maybe<Scalars['String']>;
  isAccessGranted: Access;
};


export type OAuthQueryGetPartialNricArgs = {
  state: Scalars['String'];
};


export type OAuthQueryIsAccessGrantedArgs = {
  state: Scalars['String'];
};

export type OauthContext = {
  dealId?: InputMaybe<Scalars['String']>;
  source: Source;
};

export type OauthResponse = {
  __typename?: 'OauthResponse';
  authoriseUrl: Scalars['String'];
  state: Scalars['String'];
};

export type Offers = {
  __typename?: 'Offers';
  badge?: Maybe<Badge>;
  discounts: Array<Discount>;
};

export type OffersFinanceBreakdownBlock = {
  __typename?: 'OffersFinanceBreakdownBlock';
  blocks: Array<Array<BreakdownBlockRow>>;
};

export type PageInfoData = {
  __typename?: 'PageInfoData';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Payment = {
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PaymentFee = {
  __typename?: 'PaymentFee';
  fullPaymentBalance?: Maybe<Array<Money>>;
  fullPaymentFee?: Maybe<Array<Money>>;
  inStoreDescription?: Maybe<Scalars['String']>;
  inStorePaymentFee?: Maybe<Money>;
  orderBalance?: Maybe<Array<Money>>;
  orderFee?: Maybe<Array<Money>>;
  paymentType?: Maybe<PaymentType>;
  refundableState?: Maybe<Scalars['String']>;
  reserveBalance?: Maybe<Array<Money>>;
  reserveFee?: Maybe<Array<Money>>;
};

export type PaymentFrequency = {
  __typename?: 'PaymentFrequency';
  displayLabel: Scalars['String'];
  id: Scalars['String'];
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  actionCode: Scalars['String'];
  actionDescription: Scalars['String'];
  brand: Scalars['String'];
  card: Scalars['String'];
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  inStorePayment?: Maybe<InStorePaymentAttributes>;
  transactionId: Scalars['String'];
  transactionTime: Scalars['String'];
};

export type PaymentResponse2C2P = Payment & {
  __typename?: 'PaymentResponse2C2P';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum PaymentType {
  FullPayment = 'full_payment',
  OrderCar = 'order_car',
  ReservationFee = 'reservation_fee'
}

export type PimStockCar = StockCar & {
  __typename?: 'PimStockCar';
  carId: Scalars['CarId'];
  carMatchLabel: Scalars['String'];
  /** @deprecated Use `prices` instead. */
  carPrice: CarPrice;
  disclaimer?: Maybe<Disclaimer>;
  finance: FinanceResult;
  images: Array<Image>;
  keyFeatures: Array<Feature>;
  /** @deprecated Use quote.prices instead */
  prices: Prices;
  quote: QuoteMinimal;
  selectedFeatures: SelectedFeatures;
  vin?: Maybe<Scalars['String']>;
};


export type PimStockCarDisclaimerArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};


export type PimStockCarFinanceArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type PimStockCarQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};

export type Placeholder = {
  __typename?: 'Placeholder';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  /** @deprecated Use `money.amount`. */
  amount: Scalars['Float'];
  /** @deprecated Use `money.currency`. */
  currency: Scalars['String'];
  money: Money;
  taxes?: Maybe<Array<Maybe<Tax>>>;
  type: Scalars['String'];
};

export enum PriceTypes {
  FinalPrice = 'FinalPrice',
  NetPrice = 'NetPrice'
}

export type Prices = {
  __typename?: 'Prices';
  carPrice?: Maybe<CarPrice>;
  discounts: Array<Discount>;
  governmentEvRebate?: Maybe<Array<GovernmentEvRebate>>;
  source: Scalars['String'];
  totalAmountPayable?: Maybe<Array<Price>>;
  totalConfiguration: Array<Price>;
  totalExtraFeatures: Array<Price>;
  totalFeatures: Array<Price>;
  totalNonFinanceableFeatures: Array<Price>;
  totalOfferFeatures: Array<Price>;
  totalPrice: Array<Price>;
};

export type Query = {
  __typename?: 'Query';
  authentication: AuthenticationQuery;
  bodyStyle?: Maybe<BodyStyle>;
  bodyStyles: Array<BodyStyleResult>;
  budgetFilter: BudgetFilterForm;
  carFeature: Array<Feature>;
  carSpecifications?: Maybe<Array<Maybe<VehicleSpecificationGroup>>>;
  catalog: CatalogResult;
  configurator: Configurator;
  creditOptions: CreditOptions;
  /** @deprecated Use configurator.customizeCarWithQuote and configurator.similarStockCars */
  customizeCar?: Maybe<CustomizedCarConfiguration>;
  deal: Deal;
  dealWithQuote: DealWithQuote;
  dealers?: Maybe<DealersList>;
  demoQuery: Scalars['String'];
  engine?: Maybe<Engine>;
  engines: Array<EngineResult>;
  enquiryForm: JsonForm;
  expressionOfInterest?: Maybe<Array<Maybe<ExpressionOfInterest>>>;
  featureChildren: Array<Feature>;
  finance: Finance;
  financeApplicationForm: FinanceApplicationForm;
  financeForm: FinanceForm;
  inStoreCapability: InStoreCapabilityQuery;
  insurance: Insurance;
  /** @deprecated Use authentication.isPasswordResetTokenValid */
  isPasswordResetTokenValid: Scalars['Boolean'];
  listExtraAccessories?: Maybe<ListExtraAccessories>;
  listStockCars?: Maybe<StockListingCars>;
  model?: Maybe<Model>;
  myAccount: MyAccountQuery;
  myAccountRedirectTarget: MyAccountRedirectTarget;
  oauth: OAuthQuery;
  orderOnlineExternal: Scalars['String'];
  preOrderOnlineExternal: Scalars['String'];
  /** @deprecated Use authentication.registerForm */
  registerForm: JsonForm;
  reverseCalculator: ReverseCalculator;
  salesEnablement: SalesEnablementQuery;
  searchCar: Scalars['CarId'];
  searchDealer?: Maybe<Dealer>;
  simpleFinanceFormFilter: SimpleFinanceFormResult;
  specPack?: Maybe<SpecPack>;
  specPacks: Array<SpecPackResult>;
  stockApiPing: Scalars['Boolean'];
  /** @deprecated Use query.translationsByFamily */
  translations: Array<Maybe<Translation>>;
  translationsByFamily: Array<Translation>;
  trim: Trim;
  trimLevelModels: Array<ModelResult>;
  trimLevelVariants?: Maybe<TrimLevelVariants>;
  trimLevels: Array<TrimLevel>;
};


export type QueryBodyStyleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBodyStylesArgs = {
  filters?: InputMaybe<Filters>;
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type QueryCarFeatureArgs = {
  carCode: Scalars['String'];
  featureCode: Scalars['String'];
};


export type QueryCarSpecificationsArgs = {
  carId: Scalars['CarId'];
};


export type QueryCatalogArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryCreditOptionsArgs = {
  dealId: Scalars['String'];
};


export type QueryCustomizeCarArgs = {
  carId: Scalars['CarId'];
  dealerId?: InputMaybe<Scalars['String']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  needsInteraction?: InputMaybe<Scalars['Boolean']>;
  postCode?: InputMaybe<Scalars['String']>;
  selectedFeatureIds?: InputMaybe<FeatureIdsInput>;
  vehicleConfigurationUrl?: InputMaybe<Scalars['String']>;
};


export type QueryDealArgs = {
  token: Scalars['String'];
};


export type QueryDealWithQuoteArgs = {
  token: Scalars['String'];
};


export type QueryDealersArgs = {
  postCode?: InputMaybe<Scalars['String']>;
  retailGroup?: InputMaybe<Scalars['String']>;
};


export type QueryEngineArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryEnginesArgs = {
  filters?: InputMaybe<Filters>;
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type QueryEnquiryFormArgs = {
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type QueryFeatureChildrenArgs = {
  carCode: Scalars['String'];
  featureCode: Scalars['String'];
  postCode?: InputMaybe<Scalars['String']>;
};


export type QueryFinanceApplicationFormArgs = {
  stepName?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type QueryIsPasswordResetTokenValidArgs = {
  resetToken: Scalars['String'];
};


export type QueryListStockCarsArgs = {
  byoCarId?: InputMaybe<Scalars['String']>;
  listingView?: InputMaybe<StockListingView>;
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryModelArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryMyAccountRedirectTargetArgs = {
  dealId: Scalars['String'];
};


export type QueryOrderOnlineExternalArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
  selectedCar: SelectedCarForDeal;
};


export type QueryPreOrderOnlineExternalArgs = {
  dealId: Scalars['String'];
  postCode?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCarArgs = {
  filters?: InputMaybe<Filters>;
};


export type QuerySearchDealerArgs = {
  postCode: Scalars['String'];
  retailGroup?: InputMaybe<Scalars['String']>;
};


export type QuerySimpleFinanceFormFilterArgs = {
  disableOutOfRangeTrims?: InputMaybe<Scalars['Boolean']>;
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type QuerySpecPackArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySpecPacksArgs = {
  filters?: InputMaybe<Filters>;
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
};


export type QueryTranslationsArgs = {
  component?: InputMaybe<ComponentName>;
};


export type QueryTranslationsByFamilyArgs = {
  family: Scalars['String'];
};


export type QueryTrimArgs = {
  trimCode: Scalars['TrimCode'];
};


export type QueryTrimLevelModelsArgs = {
  filters?: InputMaybe<Filters>;
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};


export type QueryTrimLevelVariantsArgs = {
  filters?: InputMaybe<Filters>;
  financeInput?: InputMaybe<FinanceInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};


export type QueryTrimLevelsArgs = {
  trimCode: Scalars['TrimCode'];
};

export type Quote = {
  __typename?: 'Quote';
  car: QuoteCar;
  disclaimers: Array<Disclaimer>;
  finance?: Maybe<FinanceQuote>;
  id: Scalars['String'];
  offers: Offers;
  prices: Prices;
};

export type QuoteCar = {
  __typename?: 'QuoteCar';
  aggregatedOptions: Scalars['String'];
  attributes: QuoteCarAttributes;
  code: Scalars['String'];
  configurationSourceUrl: Scalars['String'];
  displayName: Scalars['String'];
  featurePrices: Array<Price>;
  features: QuoteCarFeatures;
  images: Array<Image>;
  isForReservation?: Maybe<Scalars['Boolean']>;
  nonFinancedFeaturePrices: Array<Price>;
  originalPrices: Array<Price>;
  stock?: Maybe<DealStock>;
  trimLevels: TrimLevels;
};

export type QuoteCarAttributes = {
  __typename?: 'QuoteCarAttributes';
  dealerExternalId?: Maybe<Scalars['String']>;
  deliveryTimeFrame?: Maybe<DeliveryTimeFrame>;
  freebies?: Maybe<Array<Maybe<Freebies>>>;
  market?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['String']>;
  originalConfigurationSourceUrl?: Maybe<Scalars['String']>;
  priceLabel?: Maybe<Scalars['String']>;
  startConfigurationSourceUrl?: Maybe<Scalars['String']>;
};

export type QuoteCarExtraFeature = {
  __typename?: 'QuoteCarExtraFeature';
  attributes: QuoteCarExtraFeatureAttributes;
  code: Scalars['String'];
  id: Scalars['String'];
  prices: Array<Price>;
  shortName: Scalars['String'];
};

export type QuoteCarExtraFeatureAttributes = {
  __typename?: 'QuoteCarExtraFeatureAttributes';
  categoryCode?: Maybe<Scalars['String']>;
};

export type QuoteCarFeature = {
  __typename?: 'QuoteCarFeature';
  attributes: QuoteCarFeatureAttributes;
  code: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  prices: Array<Price>;
  shortName: Scalars['String'];
};

export type QuoteCarFeatureAttributes = {
  __typename?: 'QuoteCarFeatureAttributes';
  categoryCode?: Maybe<Scalars['String']>;
  childrenDetails?: Maybe<Array<Maybe<ExtraFeature>>>;
  oemcode?: Maybe<Scalars['String']>;
};

export type QuoteCarFeatures = {
  __typename?: 'QuoteCarFeatures';
  background?: Maybe<QuoteCarFeature>;
  exterior: QuoteCarFeature;
  interior?: Maybe<QuoteCarFeature>;
  roof?: Maybe<QuoteCarFeature>;
  selectedExtraFeatures?: Maybe<Array<Maybe<QuoteCarExtraFeature>>>;
  selectedFeatures: Array<QuoteCarFeature>;
  standardFeatures: Array<QuoteCarFeature>;
};

export enum QuoteError {
  CarLoading = 'carLoading',
  ConfigLoading = 'configLoading',
  FinanceCalculation = 'financeCalculation',
  FinanceNotSupported = 'financeNotSupported',
  FinanceProductNotApplicable = 'financeProductNotApplicable',
  InvalidFinanceCriteria = 'invalidFinanceCriteria'
}

export type QuoteMinimal = {
  __typename?: 'QuoteMinimal';
  disclaimers?: Maybe<Array<Disclaimer>>;
  finance: FinanceResult;
  offers: Offers;
  prices: Prices;
};


export type QuoteMinimalDisclaimersArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};

export type QuoteResult = {
  __typename?: 'QuoteResult';
  car: Car;
  quote: QuoteMinimal;
};


export type QuoteResultQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type QuoteUpdateMutation = {
  __typename?: 'QuoteUpdateMutation';
  updateFromAccessories: Quote;
  updateFromFinance: Quote;
};


export type QuoteUpdateMutationUpdateFromAccessoriesArgs = {
  quoteId: Scalars['String'];
  selectedExtraFeatures: Array<InputMaybe<Scalars['String']>>;
};


export type QuoteUpdateMutationUpdateFromFinanceArgs = {
  financeFormInput: FinanceFormInput;
  quoteId: Scalars['String'];
};

export type RegisterFormData = {
  formData: Scalars['String'];
};

export type RepaymentSection = {
  __typename?: 'RepaymentSection';
  values: Array<Money>;
};

export type ReservationBalance = {
  __typename?: 'ReservationBalance';
  balance?: Maybe<Array<Maybe<Money>>>;
  reservation?: Maybe<Array<Maybe<Money>>>;
};

export type ReservationFee = {
  __typename?: 'ReservationFee';
  price: Array<Money>;
  refundableState?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  confirmedPassword: Scalars['String'];
  password: Scalars['String'];
  resetToken: Scalars['String'];
};

export type ResidualValue = {
  __typename?: 'ResidualValue';
  value: Scalars['Float'];
};

export type ResponseFilters = {
  __typename?: 'ResponseFilters';
  bodyStyleCode?: Maybe<Scalars['String']>;
  engineCode?: Maybe<Scalars['String']>;
  modelCode?: Maybe<Scalars['String']>;
  specPackCode?: Maybe<Scalars['String']>;
  trimCode: Scalars['TrimCode'];
  variantCode?: Maybe<Scalars['String']>;
};

export type ReverseCalculator = {
  __typename?: 'ReverseCalculator';
  load: ReverseCalculatorFormResponse;
  performCalculation: ReverseCalculatorFormResponse;
};


export type ReverseCalculatorPerformCalculationArgs = {
  input: ReverseCalculatorFormInput;
};

export type ReverseCalculatorCarPrice = {
  __typename?: 'ReverseCalculatorCarPrice';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  formatted: Scalars['String'];
};

export type ReverseCalculatorFinanceJsonForm = {
  __typename?: 'ReverseCalculatorFinanceJsonForm';
  formData: ReverseCalculatorFormValues;
  schema: Scalars['String'];
  uiSchema: Scalars['String'];
};

export type ReverseCalculatorFormInput = {
  deposit: Scalars['Float'];
  duration: Scalars['Int'];
  mileage: Scalars['Int'];
  repayment: Scalars['Float'];
};

export type ReverseCalculatorFormResponse = {
  __typename?: 'ReverseCalculatorFormResponse';
  disclaimers: Array<Scalars['String']>;
  form: ReverseCalculatorFinanceJsonForm;
  price: ReverseCalculatorCarPrice;
};

export type ReverseCalculatorFormValues = {
  __typename?: 'ReverseCalculatorFormValues';
  deposit: Scalars['Float'];
  duration: Scalars['Int'];
  mileage?: Maybe<Scalars['Int']>;
  repayment?: Maybe<Scalars['Float']>;
};

export type SeSession = {
  __typename?: 'SESession';
  hasChanges: Scalars['Boolean'];
  id: Scalars['String'];
  ownerId: Scalars['String'];
  state: SeState;
};

export type SeState = {
  __typename?: 'SEState';
  carCode?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  dealerDiscount?: Maybe<Scalars['Float']>;
  dealerName: Scalars['String'];
  extraFeatures?: Maybe<Array<Scalars['String']>>;
  financeApplicationFormData?: Maybe<Scalars['String']>;
  financeFormInput?: Maybe<FinanceFormInputData>;
  insuranceApplicationFormData?: Maybe<Scalars['String']>;
  miscOptions: Array<MiscellaneousOption>;
  newVehiclePrice?: Maybe<Scalars['Float']>;
  selectedFeatures?: Maybe<Array<Scalars['String']>>;
  startConfigurationUrl?: Maybe<Scalars['String']>;
  stockInfo?: Maybe<StockInfo>;
  tradeIn?: Maybe<TradeIn>;
  userPostCode: Scalars['String'];
  userState?: Maybe<Scalars['String']>;
  vehicleConfigurationUrl?: Maybe<Scalars['String']>;
};

export type SalesEnablementDealAttributes = {
  __typename?: 'SalesEnablementDealAttributes';
  additionalNotes?: Maybe<Scalars['String']>;
  tradeIn?: Maybe<TradeIn>;
};

export type SalesEnablementFinanceApplicationFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type SalesEnablementInsuranceFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type SalesEnablementMutation = {
  __typename?: 'SalesEnablementMutation';
  logout?: Maybe<Scalars['Boolean']>;
  saveDealerChanges: Scalars['String'];
  saveFinanceApplicationForm?: Maybe<Scalars['String']>;
  saveInsuranceForm?: Maybe<Scalars['String']>;
  savePaymentForm?: Maybe<InStorePayment>;
  saveTaxForm?: Maybe<Scalars['String']>;
  selectDealer: SeSession;
  setAdditionalNotes: SuccessResponse;
  setDealerDiscount: SeSession;
  setMiscOptions: SeSession;
  setTradeIn: SeSession;
};


export type SalesEnablementMutationSaveFinanceApplicationFormArgs = {
  data?: InputMaybe<SalesEnablementFinanceApplicationFormData>;
};


export type SalesEnablementMutationSaveInsuranceFormArgs = {
  data?: InputMaybe<SalesEnablementInsuranceFormData>;
};


export type SalesEnablementMutationSavePaymentFormArgs = {
  data?: InputMaybe<SalesEnablementPaymentFormData>;
};


export type SalesEnablementMutationSaveTaxFormArgs = {
  data?: InputMaybe<SalesEnablementTaxFormData>;
};


export type SalesEnablementMutationSelectDealerArgs = {
  postCode: Scalars['String'];
};


export type SalesEnablementMutationSetAdditionalNotesArgs = {
  additionalNotes?: InputMaybe<Scalars['String']>;
};


export type SalesEnablementMutationSetDealerDiscountArgs = {
  dealerDiscount?: InputMaybe<Scalars['Float']>;
  newVehiclePrice?: InputMaybe<Scalars['Float']>;
};


export type SalesEnablementMutationSetMiscOptionsArgs = {
  options: MiscellaneousOptionInput;
};


export type SalesEnablementMutationSetTradeInArgs = {
  data?: InputMaybe<TradeInInput>;
};

export type SalesEnablementPaymentFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type SalesEnablementQuery = {
  __typename?: 'SalesEnablementQuery';
  applyDiscount: JsonForm;
  calculateTaxForm: JsonForm;
  financeApplicationForm: JsonForm;
  getQuoteFromSession: Quote;
  insuranceForm: JsonForm;
  miscOptions: Array<MiscellaneousOptionDefinitionResult>;
  paymentForm: JsonForm;
  resetTaxForm: JsonForm;
  session: SeSession;
  taxationForm: JsonForm;
  tradeIn?: Maybe<TradeIn>;
  tradeInFormData?: Maybe<Array<Maybe<Scalars['String']>>>;
  updateTaxationForm: JsonForm;
};


export type SalesEnablementQueryApplyDiscountArgs = {
  data: SalesEnablementTaxFormData;
};


export type SalesEnablementQueryCalculateTaxFormArgs = {
  data: SalesEnablementTaxFormData;
};


export type SalesEnablementQueryUpdateTaxationFormArgs = {
  data: SalesEnablementTaxFormData;
};

export type SalesEnablementTaxFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type SearchFacet = {
  __typename?: 'SearchFacet';
  id: Scalars['String'];
  options: Array<Maybe<SearchFacetOption>>;
};

export type SearchFacetOption = {
  __typename?: 'SearchFacetOption';
  attributes?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  status: FacetOptionStatus;
};

export type SearchInput = {
  bodyStyleShortNameType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyStyleType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodytypeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dimensionsFromWheelTrackType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  division?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exterior?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fuelType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  grossWeightCapacityType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interior?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  maximumPowerType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minPrice?: InputMaybe<Scalars['Int']>;
  modelType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seriesType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transmissionType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  usableCabToAxleType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variant?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleGrossWeightType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleInStockType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SelectedCar = {
  code: Scalars['String'];
  featureCodes: FeatureCodes;
  postcode?: InputMaybe<Scalars['String']>;
};

export type SelectedCarForDeal = {
  configurationSourceUrl: Scalars['String'];
  filters?: InputMaybe<Filters>;
  id?: InputMaybe<Scalars['CarId']>;
  isStock?: InputMaybe<Scalars['Boolean']>;
  selectedFeatureIds?: InputMaybe<FeatureIdsInput>;
};

export type SelectedFeatures = {
  __typename?: 'SelectedFeatures';
  added: Array<Maybe<Scalars['String']>>;
  merged: Array<Maybe<MergedFeatures>>;
  removed: Array<Maybe<Scalars['String']>>;
  requiresOneOf: Array<Maybe<Array<Maybe<Scalars['String']>>>>;
  selected: Array<Maybe<Scalars['String']>>;
};

export type ServiceInterval = {
  __typename?: 'ServiceInterval';
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<Price>>>;
};

export type Session = {
  __typename?: 'Session';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
  tokenType: TokenType;
};

export type SimpleFinanceFormResult = {
  __typename?: 'SimpleFinanceFormResult';
  count?: Maybe<Scalars['Int']>;
  nodes: Array<Maybe<TrimResult>>;
};

export type SimpleMiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'SimpleMiscellaneousOptionDefinition';
  code: Scalars['String'];
  description: Scalars['String'];
  descriptionEditable: Scalars['Boolean'];
  price: Money;
  priceEditable: Scalars['Boolean'];
};

export type SimpleMiscellaneousOptionInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  price: Scalars['Int'];
};

export type Simulation = {
  __typename?: 'Simulation';
  amountFinanced: Array<Money>;
  attributes: SimulationAttributes;
  disclaimers: Array<FinanceInfoDisclaimer>;
  interestRate?: Maybe<InterestRate>;
  roadCosts?: Maybe<Scalars['String']>;
  totalAmountPayable: Array<Money>;
  value: Array<Money>;
};

export type SimulationAttributes = {
  __typename?: 'SimulationAttributes';
  balloonAmount?: Maybe<Scalars['Float']>;
  balloonAmountPercentage?: Maybe<Scalars['Float']>;
  cae?: Maybe<Scalars['String']>;
  calculatorNetPrice?: Maybe<Scalars['Float']>;
  comparisonRate?: Maybe<Scalars['Float']>;
  creditAmountPerTerm?: Maybe<Scalars['Float']>;
  creditInsuranceAmountPerTerm?: Maybe<Scalars['Float']>;
  depositAmountPercentage?: Maybe<Scalars['Float']>;
  gpsAmountPerTerm?: Maybe<Scalars['Float']>;
  oneForOne?: Maybe<Scalars['Boolean']>;
  residualAmount?: Maybe<Scalars['Float']>;
  residualAmountPercentage?: Maybe<Scalars['Float']>;
  upfrontFees?: Maybe<Scalars['Float']>;
  vehicleInsuranceAmountPerTerm?: Maybe<Scalars['Float']>;
};

export enum Source {
  Checkout = 'checkout',
  FinanceApplication = 'financeApplication',
  Insurance = 'insurance'
}

export type SpecGroup = {
  __typename?: 'SpecGroup';
  name?: Maybe<Scalars['String']>;
  specItems: Array<Maybe<SpecItem>>;
};

export type SpecItem = {
  __typename?: 'SpecItem';
  disclaimer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SpecPack = {
  __typename?: 'SpecPack';
  attributes?: Maybe<SpecPackAttributes>;
  code: Scalars['String'];
  image?: Maybe<Image>;
};

export type SpecPackAttributes = {
  __typename?: 'SpecPackAttributes';
  brand?: Maybe<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  gvr?: Maybe<Scalars['String']>;
  isdriveaway?: Maybe<Scalars['String']>;
  /** @deprecated Use `shortname`. */
  label?: Maybe<Scalars['String']>;
  marketingcategory?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  nviccode?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  redbookcode?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
  tareweight?: Maybe<Scalars['Int']>;
};

export type SpecPackResult = {
  __typename?: 'SpecPackResult';
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  financeFormInput?: Maybe<FinanceFormInputData>;
  nextFilters?: Maybe<ResponseFilters>;
  quoteResult: QuoteResult;
  specPack: SpecPack;
};


export type SpecPackResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type StockAttribute = {
  __typename?: 'StockAttribute';
  code?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
};

export type StockAttributes = {
  __typename?: 'StockAttributes';
  engineCode?: Maybe<StockAttribute>;
  engineNumber?: Maybe<StockAttribute>;
  exteriorLabel?: Maybe<Scalars['String']>;
  interiorLabel?: Maybe<Scalars['String']>;
  inventorySource?: Maybe<StockAttribute>;
  licenseNumber?: Maybe<StockAttribute>;
  locationCode?: Maybe<StockAttribute>;
  locationName?: Maybe<Scalars['String']>;
  make?: Maybe<StockAttribute>;
  modelCode?: Maybe<StockAttribute>;
  modelNumber?: Maybe<StockAttribute>;
  status?: Maybe<StockAttribute>;
  stockDate?: Maybe<StockAttribute>;
  subModelId?: Maybe<StockAttribute>;
  vehicleName?: Maybe<StockAttribute>;
  vin?: Maybe<StockAttribute>;
};

export type StockCar = {
  carId: Scalars['CarId'];
  carMatchLabel: Scalars['String'];
  /** @deprecated Use `prices` instead. */
  carPrice: CarPrice;
  disclaimer?: Maybe<Disclaimer>;
  finance: FinanceResult;
  images: Array<Image>;
  keyFeatures: Array<Feature>;
  /** @deprecated Use quote.prices instead */
  prices: Prices;
  quote: QuoteMinimal;
  selectedFeatures: SelectedFeatures;
  vin?: Maybe<Scalars['String']>;
};


export type StockCarDisclaimerArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};


export type StockCarFinanceArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
};


export type StockCarQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postcode?: InputMaybe<Scalars['String']>;
};

export type StockInfo = {
  __typename?: 'StockInfo';
  attributes?: Maybe<Scalars['String']>;
  dms: Scalars['String'];
  engineNo?: Maybe<Scalars['String']>;
  hardlockedDateTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  softlockedDateTime?: Maybe<Scalars['String']>;
  stockDealerId?: Maybe<Scalars['String']>;
  stockLockingResultCode?: Maybe<Scalars['String']>;
  stockLockingResultMessage?: Maybe<Scalars['String']>;
  stockType?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type StockListingCar = {
  __typename?: 'StockListingCar';
  attributes?: Maybe<StockAttributes>;
  availableFeatures: Array<MountedFeatures>;
  byoCarId: Scalars['String'];
  carId: Scalars['CarId'];
  count: Scalars['Int'];
  dealer?: Maybe<Dealer>;
  disclaimer?: Maybe<Disclaimer>;
  enabled: Scalars['Boolean'];
  images: Array<Image>;
  keyFeatures: Array<Feature>;
  mountedFeatures: MountedFeatures;
  quote: QuoteMinimal;
  trimCode: Scalars['TrimCode'];
  vehicleDisplayName: Scalars['String'];
  vin?: Maybe<Scalars['String']>;
};


export type StockListingCarQuoteArgs = {
  financeFormInput?: InputMaybe<FinanceFormInput>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type StockListingCars = {
  __typename?: 'StockListingCars';
  count?: Maybe<Scalars['Int']>;
  nodes?: Maybe<Array<StockListingCar>>;
  searchFacets?: Maybe<Array<Maybe<SearchFacet>>>;
};

export enum StockListingView {
  Aggregated = 'aggregated',
  Individual = 'individual'
}

export enum StockType {
  Dealer = 'dealer',
  Distribution = 'distribution'
}

export type StripePaymentResponse = Payment & {
  __typename?: 'StripePaymentResponse';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type SubaruAuMiscellaneousOptionDefinition = MiscellaneousOptionDefinitionResult & {
  __typename?: 'SubaruAUMiscellaneousOptionDefinition';
  category: Scalars['String'];
  categoryName: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  descriptionEditable: Scalars['Boolean'];
  gstExempt: Scalars['Boolean'];
  price: Money;
  priceEditable: Scalars['Boolean'];
};

export type SubaruAuMiscellaneousOptionInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  gst: Scalars['Int'];
  gstExempt: Scalars['Boolean'];
  price: Scalars['Int'];
  total: Scalars['Int'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean'];
};

export type Tax = {
  __typename?: 'Tax';
  aggregated?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  money: Money;
  type: Scalars['String'];
};

export type Term = {
  __typename?: 'Term';
  unit: TermUnit;
  value: Scalars['Int'];
};

export enum TermUnit {
  Month = 'month'
}

export enum TokenType {
  Bearer = 'BEARER'
}

export type Tooltip = {
  __typename?: 'Tooltip';
  text?: Maybe<Scalars['String']>;
  tooltipPlaceholders: Array<Placeholder>;
};

export type TotalDepositSection = {
  __typename?: 'TotalDepositSection';
  type: DepositType;
  values: Array<Money>;
};

export type TradeIn = {
  __typename?: 'TradeIn';
  amountPayable?: Maybe<Scalars['Float']>;
  tradeInAmount?: Maybe<Scalars['Float']>;
  tradeInComment?: Maybe<Scalars['String']>;
  tradeInMake?: Maybe<Scalars['String']>;
  tradeInMileage?: Maybe<Scalars['String']>;
  tradeInModel?: Maybe<Scalars['String']>;
  tradeInRegistrationNumber?: Maybe<Scalars['String']>;
  tradeInVariant?: Maybe<Scalars['String']>;
  tradeInYear?: Maybe<Scalars['String']>;
};

export type TradeInInput = {
  amountPayable: Scalars['Float'];
  tradeInAmount: Scalars['Float'];
  tradeInComment?: InputMaybe<Scalars['String']>;
  tradeInMake?: InputMaybe<Scalars['String']>;
  tradeInMileage?: InputMaybe<Scalars['String']>;
  tradeInModel?: InputMaybe<Scalars['String']>;
  tradeInRegistrationNumber?: InputMaybe<Scalars['String']>;
  tradeInVariant?: InputMaybe<Scalars['String']>;
  tradeInYear?: InputMaybe<Scalars['String']>;
};

export type TradeInResult = {
  __typename?: 'TradeInResult';
  equity: Money;
};

export type Translation = {
  __typename?: 'Translation';
  code: Scalars['String'];
  value: Scalars['String'];
};

export type Trim = {
  __typename?: 'Trim';
  attributes?: Maybe<TrimAttributes>;
  code: Scalars['TrimCode'];
  id: Scalars['TrimId'];
  image?: Maybe<Image>;
  trimLevels: Array<TrimLevel>;
};

export type TrimAttributes = {
  __typename?: 'TrimAttributes';
  brand?: Maybe<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use selectCar.disclaimers() */
  generalDisclaimer?: Maybe<Array<Scalars['String']>>;
  group?: Maybe<Scalars['String']>;
  isSoldOut?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use `shortname`. */
  label?: Maybe<Scalars['String']>;
  marketingprefix?: Maybe<Scalars['String']>;
  modelyear?: Maybe<Scalars['String']>;
  oemcode?: Maybe<Scalars['String']>;
  shortname?: Maybe<Scalars['String']>;
  soldOutAction?: Maybe<Scalars['String']>;
  soldOutBrochureUrl?: Maybe<Scalars['String']>;
};

export type TrimLevel = {
  __typename?: 'TrimLevel';
  id: Scalars['Int'];
  label: Scalars['String'];
  type: Scalars['String'];
};

export type TrimLevelVariants = {
  __typename?: 'TrimLevelVariants';
  financeFormInput?: Maybe<FinanceFormInputData>;
  marketingCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  variants: Array<Maybe<VariantResult>>;
};

export type TrimLevels = {
  __typename?: 'TrimLevels';
  bodyStyle?: Maybe<BodyStyle>;
  engine?: Maybe<Engine>;
  model?: Maybe<Model>;
  nameplate?: Maybe<Nameplate>;
  specificationPack?: Maybe<SpecPack>;
};

export type TrimResult = {
  __typename?: 'TrimResult';
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  enabled?: Maybe<Scalars['Boolean']>;
  group?: Maybe<Scalars['Int']>;
  nextFilters?: Maybe<ResponseFilters>;
  quoteResult: QuoteResult;
  trim: Trim;
};


export type TrimResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type UtmDetailsInput = {
  campaign: Scalars['String'];
  content: Scalars['String'];
  medium: Scalars['String'];
  source: Scalars['String'];
  term: Scalars['String'];
};

export type UserDetailsFormData = {
  formData?: InputMaybe<Scalars['String']>;
};

export type Variant = {
  __typename?: 'Variant';
  attributes?: Maybe<VariantAttributes>;
  code: Scalars['String'];
  image?: Maybe<Image>;
  interiorimage?: Maybe<Image>;
  rearimage?: Maybe<Image>;
  sideimage?: Maybe<Image>;
};

export type VariantAttributes = {
  __typename?: 'VariantAttributes';
  bodyStyleType?: Maybe<Scalars['String']>;
  cO2?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['String']>;
  engineCapacity?: Maybe<Scalars['Int']>;
  featureGroups?: Maybe<Array<Maybe<FeatureGroup>>>;
  fuelType: Array<Scalars['String']>;
  fullSpecsUrl?: Maybe<Scalars['String']>;
  gvr?: Maybe<Scalars['String']>;
  insurerCode?: Maybe<Scalars['String']>;
  isDriveAway?: Maybe<Scalars['Boolean']>;
  isElectric?: Maybe<Scalars['Boolean']>;
  isHybrid?: Maybe<Scalars['Boolean']>;
  keyFeatures: Array<VariantKeyFeature>;
  marketingCategory?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  performanceRating?: Maybe<Scalars['String']>;
  seriesName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  specGroups?: Maybe<Array<Maybe<SpecGroup>>>;
  spotId?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  vehicleModelId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type VariantKeyFeature = {
  __typename?: 'VariantKeyFeature';
  description: Scalars['String'];
  disclaimer?: Maybe<Scalars['String']>;
};

export type VariantResult = {
  __typename?: 'VariantResult';
  /** @deprecated Use `carConfig.car`. */
  car: Car;
  carConfig: CarConfiguration;
  nextFilters?: Maybe<ResponseFilters>;
  variant: Variant;
};


export type VariantResultCarConfigArgs = {
  financeInput?: InputMaybe<FinanceInput>;
  financeProductId?: InputMaybe<Scalars['FinanceProductId']>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type VehicleSpecificationGroup = {
  __typename?: 'VehicleSpecificationGroup';
  displayOrder?: Maybe<Scalars['Int']>;
  groupName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  specItems: Array<Maybe<VehicleSpecificationItem>>;
};

export type VehicleSpecificationItem = {
  __typename?: 'VehicleSpecificationItem';
  disclaimer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type VisaNetPaymentResponse = Payment & {
  __typename?: 'VisaNetPaymentResponse';
  amount?: Maybe<Scalars['String']>;
  cardHolderEmail?: Maybe<Scalars['String']>;
  cardHolderLastName?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  merchantId?: Maybe<Scalars['String']>;
  purchaseNumber?: Maybe<Scalars['Int']>;
  sessionToken?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type WebpayPaymentResponse = Payment & {
  __typename?: 'WebpayPaymentResponse';
  errors?: Maybe<Array<Maybe<PaymentError>>>;
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CarPricesFragment = { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } };

export type DealDataFragment = { __typename?: 'Deal', uuid: string, disabled?: DisabledDeal | null, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, currency: string, region: string, country: string, brand: string, language: string, createdAt: string, updatedAt: string, car: { __typename?: 'DealCustomizedCarConfiguration', code: string, displayName?: string | null, aggregatedOptions?: string | null, configurationSourceUrl: string, images?: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }> | null, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null, modelyear?: string | null, oemcode?: string | null } | null } | null, interior?: { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, exterior?: { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, variant?: { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null } | null, engine?: { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null } | null, specPack?: { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null } | null } | null, prices?: { __typename?: 'DealPrices', carPrice?: { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, totalNonFinanceableFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null } | null, standardFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, selectedFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null, attributes?: { __typename?: 'CarAttributes', priceLabel?: string | null, coeCategoryAmount?: Array<{ __typename?: 'COECategoryAmount', amount?: string | null, currency?: string | null } | null> | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null } | null }, paymentInfo: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, insurance?: { __typename?: 'DealInsurance', applicationStatus?: string | null, applicationDate?: string | null, applicationAmended?: boolean | null, policy?: Array<{ __typename?: 'InsurancePolicy', money: { __typename?: 'Money', amount: number, currency: string } } | null> | null } | null, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, finance?: { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null } | null, financeApplication?: { __typename?: 'FinanceApplication', result?: string | null, status?: string | null, submissionId?: string | null, callbackRequested?: boolean | null, financeApplicationJourney?: FinanceApplicationJourney | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, location?: { __typename?: 'Location', province?: string | null, district?: string | null, street?: string | null } | null, attributes?: { __typename?: 'DealAttributes', market?: string | null, modelyear?: number | null, co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, tradeInColour?: string | null, tradeInVariant?: string | null, vehicleDetailsPageUrl?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null, salesEnablement?: { __typename?: 'SalesEnablementDealAttributes', additionalNotes?: string | null, tradeIn?: { __typename?: 'TradeIn', tradeInAmount?: number | null, amountPayable?: number | null } | null } | null } | null };

export type ExpressionOfInterestFragment = { __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null };

export type MountedFeatureFragment = { __typename?: 'MountedFeature', code: string, shortname: string, image?: Array<{ __typename?: 'Image', url?: string | null } | null> | null };

export type MountedFeaturesFragment = { __typename?: 'MountedFeatures', exterior: { __typename?: 'MountedFeature', code: string, shortname: string, image?: Array<{ __typename?: 'Image', url?: string | null } | null> | null }, interior?: { __typename?: 'MountedFeature', code: string, shortname: string, image?: Array<{ __typename?: 'Image', url?: string | null } | null> | null } | null };

export type PaymentInfoFragment = { __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string };

export type QuoteFragment = { __typename?: 'Quote', id: string, prices: { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> }, disclaimers: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null }, finance?: { __typename?: 'FinanceQuote', simulation: { __typename?: 'Simulation', roadCosts?: string | null, value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> }, criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null } } | null, car: { __typename?: 'QuoteCar', code: string, displayName: string, aggregatedOptions: string, configurationSourceUrl: string, isForReservation?: boolean | null, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, attributes: { __typename?: 'QuoteCarAttributes', startConfigurationSourceUrl?: string | null, priceLabel?: string | null, deliveryTimeFrame?: { __typename?: 'DeliveryTimeFrame', deliveryTimeFrameLabel?: string | null } | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null }, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, trimLevels: { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null }, features: { __typename?: 'QuoteCarFeatures', selectedFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }>, selectedExtraFeatures?: Array<{ __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null> | null, interior?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, exterior: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }, roof?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, standardFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null } }> } } };

export type QuoteCarFragment = { __typename?: 'QuoteCar', code: string, displayName: string, aggregatedOptions: string, configurationSourceUrl: string, isForReservation?: boolean | null, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, attributes: { __typename?: 'QuoteCarAttributes', startConfigurationSourceUrl?: string | null, priceLabel?: string | null, deliveryTimeFrame?: { __typename?: 'DeliveryTimeFrame', deliveryTimeFrameLabel?: string | null } | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null }, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, trimLevels: { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null }, features: { __typename?: 'QuoteCarFeatures', selectedFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }>, selectedExtraFeatures?: Array<{ __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null> | null, interior?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, exterior: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }, roof?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, standardFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null } }> } };

export type QuoteExtraFeatureFragment = { __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> };

export type QuoteFeatureFragment = { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> };

export type QuoteFinanceFragment = { __typename?: 'FinanceQuote', criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null }, simulation: { __typename?: 'Simulation', value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> } };

export type CommonQuoteMinimalFragment = { __typename?: 'QuoteMinimal', prices: { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> }, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null }, finance: { __typename?: 'FinanceResult', type: FinanceResultType, editText?: string | null, quote?: { __typename?: 'FinanceQuote', criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null }, simulation: { __typename?: 'Simulation', value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> } } | null, disclaimers: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> }, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null };

export type QuotePricesFragment = { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> };

export type QuoteTrimLevelsFragment = { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null };

export type AppointmentDetailsFragment = { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null };

export type BadgeFragment = { __typename?: 'Badge', image: string, label?: string | null };

export type BaseImageFragment = { __typename?: 'Image', url?: string | null, type?: string | null };

export type CheckoutBodyStyleFragment = { __typename?: 'BodyStyle', code: string, attributes?: { __typename?: 'BodyStyleAttributes', shortname?: string | null, longdescription?: string | null, bodyStyleType?: string | null, oemcode?: string | null } | null };

export type CarPriceFragment = { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } };

export type CarPriceWithTaxFragment = { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } };

export type CriteriaFragment = { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', id: string, displayLabel: string }, paymentFrequency: { __typename?: 'PaymentFrequency', id: string, displayLabel: string }, term: { __typename?: 'Term', value: number }, deposits: Array<{ __typename?: 'DepositCriteria', value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, ageRange?: { __typename?: 'AgeRange', value: string } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null };

export type CustomerFragment = { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null };

export type CustomerAttributesFragment = { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null };

export type CustomerDetailsFragment = { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null };

export type DealCarPriceFragment = { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null };

export type DealFeatureFragment = { __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null };

export type DealFinanceFragment = { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null };

export type DealWithQuoteFragment = { __typename?: 'DealWithQuote', uuid: string, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, paymentInfo?: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, quote: { __typename?: 'Quote', id: string, prices: { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> }, disclaimers: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null }, finance?: { __typename?: 'FinanceQuote', simulation: { __typename?: 'Simulation', roadCosts?: string | null, value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> }, criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null } } | null, car: { __typename?: 'QuoteCar', code: string, displayName: string, aggregatedOptions: string, configurationSourceUrl: string, isForReservation?: boolean | null, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, attributes: { __typename?: 'QuoteCarAttributes', startConfigurationSourceUrl?: string | null, priceLabel?: string | null, deliveryTimeFrame?: { __typename?: 'DeliveryTimeFrame', deliveryTimeFrameLabel?: string | null } | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null }, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, trimLevels: { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null }, features: { __typename?: 'QuoteCarFeatures', selectedFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }>, selectedExtraFeatures?: Array<{ __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null> | null, interior?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, exterior: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }, roof?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, standardFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null } }> } } }, attributes: { __typename?: 'DealAttributes', co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, tradeInColour?: string | null, tradeInVariant?: string | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, vehicleDetailsPageUrl?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null, salesEnablement?: { __typename?: 'SalesEnablementDealAttributes', additionalNotes?: string | null, tradeIn?: { __typename?: 'TradeIn', tradeInAmount?: number | null, amountPayable?: number | null } | null } | null } };

export type DealerFragment = { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null };

export type DisclaimerFragment = { __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean };

export type DiscountFragment = { __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> };

export type EngineFragment = { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null };

export type ExteriorFragment = { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null };

export type FinanceFragment = { __typename?: 'FinanceResult', type: FinanceResultType, simulation?: { __typename?: 'FinanceSimulation', interestRate?: number | null, comparisonRate?: number | null, frequency?: string | null, paymentValue?: Array<{ __typename?: 'FinanceValue', currency: string, amount: number }> | null, loanTermPeriod?: { __typename?: 'LoanTermPeriod', value?: number | null, unit?: LoanTermPeriodUnit | null } | null, deposits?: Array<{ __typename?: 'Deposit', value: number, type: DepositType } | null> | null } | null };

export type FinanceFormInputFragment = { __typename?: 'FinanceFormInputData', ageRange?: string | null, paymentType: FinanceFormType, financeProductId?: string | null, financePackageId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, partExchangeId?: string | null, homeOwner?: string | null, mileage?: number | null, residualValue?: number | null };

export type FinanceValueFragment = { __typename?: 'FinanceValue', amount: number, currency: string };

export type InteriorFragment = { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null };

export type ListingAttributesFragment = { __typename?: 'StockAttributes', exteriorLabel?: string | null, interiorLabel?: string | null, vin?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, stockDate?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, make?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, modelNumber?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, engineCode?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, modelCode?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, engineNumber?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, licenseNumber?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, subModelId?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, locationCode?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, status?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null, inventorySource?: { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null } | null };

export type ListingFeaturesFragment = { __typename?: 'Feature', shortname: string, code: string };

export type ModelFragment = { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null };

export type MoneyFragment = { __typename?: 'Money', amount: number, currency: string };

export type OffersFragment = { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> };

export type PaymentFeeFragment = { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null };

export type PriceFragment = { __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } };

export type PriceWithTaxFragment = { __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null };

export type PricesFragment = { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> };

export type SimilarStockCarsFragment = { __typename?: 'PimStockCar', carId: any, vin?: string | null, carMatchLabel: string, selectedFeatures: { __typename?: 'SelectedFeatures', selected: Array<string | null>, added: Array<string | null>, removed: Array<string | null>, requiresOneOf: Array<Array<string | null> | null>, merged: Array<{ __typename?: 'MergedFeatures', merged: Array<string | null>, into?: string | null } | null> }, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, carPrice: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } }, finance: { __typename?: 'FinanceResult', type: FinanceResultType, simulation?: { __typename?: 'FinanceSimulation', interestRate?: number | null, comparisonRate?: number | null, frequency?: string | null, paymentValue?: Array<{ __typename?: 'FinanceValue', currency: string, amount: number }> | null, loanTermPeriod?: { __typename?: 'LoanTermPeriod', value?: number | null, unit?: LoanTermPeriodUnit | null } | null, deposits?: Array<{ __typename?: 'Deposit', value: number, type: DepositType } | null> | null } | null }, keyFeatures: Array<{ __typename?: 'Feature', id?: number | null, shortname: string, shortDescription?: string | null, longDescription?: string | null, code: string, categoryCode?: string | null }> };

export type SimulationFragment = { __typename?: 'Simulation', value: Array<{ __typename?: 'Money', amount: number, currency: string }>, totalAmountPayable: Array<{ __typename?: 'Money', amount: number, currency: string }>, amountFinanced: Array<{ __typename?: 'Money', amount: number, currency: string }>, interestRate?: { __typename?: 'InterestRate', value: number } | null };

export type SpecPackFragment = { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null };

export type StockAttributeFragment = { __typename?: 'StockAttribute', code?: string | null, shortname?: string | null };

export type TaxesFragment = { __typename?: 'Price', taxes?: Array<{ __typename?: 'Tax', type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null };

export type VariantFragment = { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null };

export type GetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranslationsQuery = { __typename?: 'Query', translations: Array<{ __typename?: 'Translation', code: string, value: string } | null> };

export type GetTranslationsByFamilyQueryVariables = Exact<{
  family: Scalars['String'];
}>;


export type GetTranslationsByFamilyQuery = { __typename?: 'Query', translationsByFamily: Array<{ __typename: 'Translation', code: string, value: string }> };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  confirmedPassword: Scalars['String'];
  dealId: Scalars['String'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: boolean };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  confirmedPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', myAccount: { __typename?: 'MyAccountMutation', changePassword: boolean } };

export type LogoutClientMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutClientMutation = { __typename?: 'Mutation', myAccount: { __typename?: 'MyAccountMutation', logout: boolean } };

export type UpdatePersonalDetailsMutationVariables = Exact<{
  data: UserDetailsFormData;
}>;


export type UpdatePersonalDetailsMutation = { __typename?: 'Mutation', myAccount: { __typename?: 'MyAccountMutation', updatePersonalDetails: { __typename?: 'Customer', firstName?: string | null, lastName?: string | null } } };

export type GetPersonalDetailsFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalDetailsFormQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', updatePersonalDetailsForm: { __typename?: 'JsonForm', schema?: string | null, uiSchema?: string | null, formData?: string | null } } };

export type CheckIfCurrentPasswordIsValidQueryVariables = Exact<{
  currentPassword: Scalars['String'];
}>;


export type CheckIfCurrentPasswordIsValidQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', isCurrentPasswordValid: boolean } };

export type MyAccountDealDataFragment = { __typename?: 'Deal', uuid: string, disabled?: DisabledDeal | null, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, currency: string, region: string, country: string, brand: string, language: string, createdAt: string, updatedAt: string, car: { __typename?: 'DealCustomizedCarConfiguration', code: string, displayName?: string | null, configurationSourceUrl: string, images?: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }> | null, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null } | null, nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null, oemcode?: string | null } | null } | null, interior?: { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, exterior?: { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, variant?: { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null } | null, engine?: { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null } | null, specPack?: { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null } | null } | null, prices?: { __typename?: 'DealPrices', carPrice?: { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, totalNonFinanceableFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null } | null, standardFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, selectedFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null, attributes?: { __typename?: 'CarAttributes', priceLabel?: string | null, coeCategoryAmount?: Array<{ __typename?: 'COECategoryAmount', amount?: string | null, currency?: string | null } | null> | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null } | null }, paymentInfo: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, insurance?: { __typename?: 'DealInsurance', applicationStatus?: string | null, applicationDate?: string | null, applicationAmended?: boolean | null, policy?: Array<{ __typename?: 'InsurancePolicy', money: { __typename?: 'Money', amount: number, currency: string } } | null> | null } | null, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, finance?: { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null } | null, financeApplication?: { __typename?: 'FinanceApplication', result?: string | null, status?: string | null, financeApplicationJourney?: FinanceApplicationJourney | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, location?: { __typename?: 'Location', district?: string | null, street?: string | null } | null, attributes?: { __typename?: 'DealAttributes', market?: string | null, co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, tradeInColour?: string | null, tradeInVariant?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null };

export type SlimDealDataFragment = { __typename?: 'Deal', uuid: string, disabled?: DisabledDeal | null, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, currency: string, region: string, country: string, brand: string, language: string, createdAt: string, updatedAt: string, car: { __typename?: 'DealCustomizedCarConfiguration', code: string, displayName?: string | null, configurationSourceUrl: string, images?: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }> | null, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null } | null, nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null, oemcode?: string | null } | null } | null, interior?: { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, exterior?: { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, variant?: { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null } | null, engine?: { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null } | null, specPack?: { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null } | null } | null, prices?: { __typename?: 'DealPrices', carPrice?: { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, totalNonFinanceableFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null } | null, standardFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, selectedFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null, attributes?: { __typename?: 'CarAttributes', priceLabel?: string | null, coeCategoryAmount?: Array<{ __typename?: 'COECategoryAmount', amount?: string | null, currency?: string | null } | null> | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null } | null }, paymentInfo: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, insurance?: { __typename?: 'DealInsurance', applicationStatus?: string | null, applicationDate?: string | null, applicationAmended?: boolean | null, policy?: Array<{ __typename?: 'InsurancePolicy', money: { __typename?: 'Money', amount: number, currency: string } } | null> | null } | null, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, finance?: { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null } | null, financeApplication?: { __typename?: 'FinanceApplication', result?: string | null, status?: string | null, financeApplicationJourney?: FinanceApplicationJourney | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, location?: { __typename?: 'Location', district?: string | null, street?: string | null } | null, attributes?: { __typename?: 'DealAttributes', market?: string | null, co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, tradeInColour?: string | null, tradeInVariant?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null };

export type InitForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type InitForgotPasswordMutation = { __typename?: 'Mutation', initForgotPassword: boolean };

export type SubmitRegisterFormMutationVariables = Exact<{
  data: RegisterFormData;
}>;


export type SubmitRegisterFormMutation = { __typename?: 'Mutation', authentication: { __typename?: 'AuthenticationMutation', register: boolean } };

export type RemoveEnquiriesMutationVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type RemoveEnquiriesMutation = { __typename?: 'Mutation', myAccount: { __typename?: 'MyAccountMutation', removeEnquiries: boolean } };

export type RemoveSavedCarMutationVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type RemoveSavedCarMutation = { __typename?: 'Mutation', myAccount: { __typename?: 'MyAccountMutation', removeSavedCar: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', currentUser: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } } };

export type GetDealQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetDealQuery = { __typename?: 'Query', deal: { __typename?: 'Deal', uuid: string, disabled?: DisabledDeal | null, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, currency: string, region: string, country: string, brand: string, language: string, createdAt: string, updatedAt: string, car: { __typename?: 'DealCustomizedCarConfiguration', code: string, displayName?: string | null, aggregatedOptions?: string | null, configurationSourceUrl: string, images?: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }> | null, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null, modelyear?: string | null, oemcode?: string | null } | null } | null, interior?: { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, exterior?: { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, variant?: { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null } | null, engine?: { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null } | null, specPack?: { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null } | null } | null, prices?: { __typename?: 'DealPrices', carPrice?: { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, totalNonFinanceableFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null } | null, standardFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, selectedFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null, attributes?: { __typename?: 'CarAttributes', priceLabel?: string | null, coeCategoryAmount?: Array<{ __typename?: 'COECategoryAmount', amount?: string | null, currency?: string | null } | null> | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null } | null }, paymentInfo: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, insurance?: { __typename?: 'DealInsurance', applicationStatus?: string | null, applicationDate?: string | null, applicationAmended?: boolean | null, policy?: Array<{ __typename?: 'InsurancePolicy', money: { __typename?: 'Money', amount: number, currency: string } } | null> | null } | null, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, finance?: { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null } | null, financeApplication?: { __typename?: 'FinanceApplication', result?: string | null, status?: string | null, submissionId?: string | null, callbackRequested?: boolean | null, financeApplicationJourney?: FinanceApplicationJourney | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, location?: { __typename?: 'Location', province?: string | null, district?: string | null, street?: string | null } | null, attributes?: { __typename?: 'DealAttributes', market?: string | null, modelyear?: number | null, co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, tradeInColour?: string | null, tradeInVariant?: string | null, vehicleDetailsPageUrl?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null, salesEnablement?: { __typename?: 'SalesEnablementDealAttributes', additionalNotes?: string | null, tradeIn?: { __typename?: 'TradeIn', tradeInAmount?: number | null, amountPayable?: number | null } | null } | null } | null } };

export type GetDealWithCustomerQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetDealWithCustomerQuery = { __typename?: 'Query', deal: { __typename: 'Deal', journeyType: JourneyType, customer?: { __typename: 'Customer', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null } };

export type GetDealWithQuoteQueryVariables = Exact<{
  token: Scalars['String'];
  dataLayer?: Scalars['Boolean'];
  isPayment?: Scalars['Boolean'];
}>;


export type GetDealWithQuoteQuery = { __typename?: 'Query', dealWithQuote: { __typename?: 'DealWithQuote', uuid: string, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, paymentInfo?: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, quote: { __typename?: 'Quote', id: string, prices: { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> }, disclaimers: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null }, finance?: { __typename?: 'FinanceQuote', simulation: { __typename?: 'Simulation', roadCosts?: string | null, value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> }, criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null } } | null, car: { __typename?: 'QuoteCar', code: string, displayName: string, aggregatedOptions: string, configurationSourceUrl: string, isForReservation?: boolean | null, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, attributes: { __typename?: 'QuoteCarAttributes', startConfigurationSourceUrl?: string | null, priceLabel?: string | null, deliveryTimeFrame?: { __typename?: 'DeliveryTimeFrame', deliveryTimeFrameLabel?: string | null } | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null }, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, trimLevels: { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null }, features: { __typename?: 'QuoteCarFeatures', selectedFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }>, selectedExtraFeatures?: Array<{ __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null> | null, interior?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, exterior: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }, roof?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, standardFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null } }> } } }, attributes: { __typename?: 'DealAttributes', co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, tradeInColour?: string | null, tradeInVariant?: string | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, vehicleDetailsPageUrl?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null, salesEnablement?: { __typename?: 'SalesEnablementDealAttributes', additionalNotes?: string | null, tradeIn?: { __typename?: 'TradeIn', tradeInAmount?: number | null, amountPayable?: number | null } | null } | null } } };

export type GetDealsPageQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  dealTypes?: InputMaybe<Array<DealTypes> | DealTypes>;
  withFinance?: InputMaybe<Scalars['Boolean']>;
  withInsurance?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDealsPageQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', dealsPage: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', cursor: string, node: { __typename?: 'Deal', uuid: string, disabled?: DisabledDeal | null, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, currency: string, region: string, country: string, brand: string, language: string, createdAt: string, updatedAt: string, car: { __typename?: 'DealCustomizedCarConfiguration', code: string, displayName?: string | null, configurationSourceUrl: string, images?: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }> | null, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null } | null, nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null, oemcode?: string | null } | null } | null, interior?: { __typename?: 'Interior', shortname: string, categoryCode?: string | null, code: string, attributes?: { __typename?: 'InteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, exterior?: { __typename?: 'Exterior', code: string, categoryCode?: string | null, shortname: string, attributes?: { __typename?: 'ExteriorAttributes', oemcode: string } | null, price?: { __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } } | null } | null, variant?: { __typename?: 'Variant', code: string, attributes?: { __typename?: 'VariantAttributes', name?: string | null, year?: string | null, modelName?: string | null, fullSpecsUrl?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', oemcode?: string | null, shortname?: string | null, modelyear?: string | null, brand?: string | null, fullSpecsUrl?: string | null, longdescription?: string | null, label: string } | null } | null, engine?: { __typename?: 'Engine', code: string, attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, shortdescription?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, transmissionLabel?: string | null, maximumpower?: string | null, maximumtorque?: string | null, enginepower?: string | null, transmissionType?: string | null, acceleration?: string | null, fueleconomy_wltpconsumption_teh?: string | null } | null } | null, specPack?: { __typename?: 'SpecPack', code: string, attributes?: { __typename?: 'SpecPackAttributes', shortname?: string | null, nviccode?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null } | null } | null, prices?: { __typename?: 'DealPrices', carPrice?: { __typename?: 'DealCarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers?: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } | null } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, totalNonFinanceableFeatures?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null } | null, standardFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, selectedFeatures?: Array<{ __typename?: 'DealFeature', id?: number | null, shortname: string, code: string, categoryCode?: string | null, prices?: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> | null, attributes?: { __typename?: 'DealFeatureAttributes', childrenDetails: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string }> } | null }> | null, disclaimers?: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }> | null, attributes?: { __typename?: 'CarAttributes', priceLabel?: string | null, coeCategoryAmount?: Array<{ __typename?: 'COECategoryAmount', amount?: string | null, currency?: string | null } | null> | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null } | null }, paymentInfo: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, insurance?: { __typename?: 'DealInsurance', applicationStatus?: string | null, applicationDate?: string | null, applicationAmended?: boolean | null, policy?: Array<{ __typename?: 'InsurancePolicy', money: { __typename?: 'Money', amount: number, currency: string } } | null> | null } | null, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, finance?: { __typename?: 'DealFinance', type?: string | null, formInput?: { __typename?: 'FormInput', paymentType: FinanceFormType, financeProductId?: string | null, term?: number | null, deposit?: number | null, interestRate?: number | null, mileage?: number | null, homeOwner?: string | null } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, interestRate?: number | null, frequency: string, financePackageId?: string | null, financeProductId?: string | null, financeProductName?: string | null, oneForOne?: boolean | null, roadCosts?: string | null, amountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', unit?: LoanTermPeriodUnit | null, value?: number | null }, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, attributes?: { __typename?: 'DealFinanceAttributes', depositAmountPercentage?: number | null, calculatorNetPrice?: string | null, balloonAmountPercentage?: string | null, residualAmountPercentage?: string | null, cae?: string | null, upfrontFees?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null, residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null, breakdown?: { __typename?: 'FinanceBreakdownJsonSchema', schema: string } | null } | null, financeApplication?: { __typename?: 'FinanceApplication', result?: string | null, status?: string | null, financeApplicationJourney?: FinanceApplicationJourney | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, location?: { __typename?: 'Location', district?: string | null, street?: string | null } | null, attributes?: { __typename?: 'DealAttributes', market?: string | null, co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, tradeInColour?: string | null, tradeInVariant?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null } } | null>, pageInfo: { __typename?: 'PageInfoData', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetDealsWithQuotePageQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  dealTypes?: InputMaybe<Array<DealTypes> | DealTypes>;
  withFinance?: InputMaybe<Scalars['Boolean']>;
  withInsurance?: InputMaybe<Scalars['Boolean']>;
  isPayment?: Scalars['Boolean'];
  dataLayer?: Scalars['Boolean'];
}>;


export type GetDealsWithQuotePageQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', dealWithQuotePage: { __typename?: 'DealWithQuoteConnection', edges: Array<{ __typename?: 'DealWithQuoteEdge', cursor: string, node: { __typename?: 'DealWithQuote', uuid: string, disabledReasons?: Array<DisabledDeal> | null, status: string, journeyType: JourneyType, paymentInfo?: Array<{ __typename?: 'PaymentInfo', errorCode?: string | null, errorMessage?: string | null, actionCode: string, actionDescription: string, transactionId: string, transactionTime: string, card: string, brand: string } | null>, expressionsOfInterest: Array<{ __typename?: 'ExpressionOfInterest', code: string, enabled?: boolean | null, attributes?: { __typename?: 'ExpressionOfInterestData', picture: string, label: string, description?: string | null } | null }>, dealer?: { __typename?: 'Dealer', externalId: string, label: string, postCode: string, attributes?: { __typename?: 'DealerAttributes', publicToken?: string | null } | null, address?: { __typename?: 'DealerAddress', name?: string | null, address?: string | null, city?: string | null, phone?: string | null } | null } | null, customer?: { __typename?: 'Customer', salutation?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, identificationNumber?: string | null, marketingInformation?: boolean | null, companyName?: string | null, customerType?: string | null, attributes?: { __typename?: 'CustomerAttributes', salutation?: string | null, postCode?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, areaCode?: string | null, areaCodeKey?: string | null, preferredContactMethod?: string | null, identificationNumber?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', preferredDate?: string | null, preferredTime?: string | null, attributes?: { __typename?: 'AppointmentAttributes', comments?: string | null, salesConsultant?: string | null } | null } | null, quote: { __typename?: 'Quote', id: string, prices: { __typename?: 'Prices', carPrice?: { __typename?: 'CarPrice', originalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalDiscount: Array<{ __typename?: 'Money', amount: number, currency: string }>, finalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }> } } | null, totalPrice: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string }, taxes?: Array<{ __typename?: 'Tax', aggregated?: boolean | null, type: string, label: string, money: { __typename?: 'Money', amount: number, currency: string } } | null> | null }>, totalConfiguration: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, totalFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }>, discounts: Array<{ __typename?: 'Discount', code?: string | null, label: string, disclaimer?: string | null, badge: { __typename?: 'Badge', image: string, label?: string | null }, value: Array<{ __typename?: 'Money', amount: number, currency: string }> }>, totalOfferFeatures: Array<{ __typename?: 'Price', type: string, money: { __typename?: 'Money', amount: number, currency: string } }> }, disclaimers: Array<{ __typename?: 'Disclaimer', value: string, purpose?: string | null, needsToBeTranslated: boolean }>, offers: { __typename?: 'Offers', badge?: { __typename?: 'Badge', image: string, label?: string | null } | null }, finance?: { __typename?: 'FinanceQuote', simulation: { __typename?: 'Simulation', roadCosts?: string | null, value: Array<{ __typename?: 'Money', currency: string, amount: number }>, totalAmountPayable: Array<{ __typename?: 'Money', currency: string, amount: number }>, amountFinanced: Array<{ __typename?: 'Money', currency: string, amount: number }>, interestRate?: { __typename?: 'InterestRate', value: number } | null, attributes: { __typename?: 'SimulationAttributes', comparisonRate?: number | null, oneForOne?: boolean | null, balloonAmountPercentage?: number | null, depositAmountPercentage?: number | null, residualAmountPercentage?: number | null, cae?: string | null, upfrontFees?: number | null, residualAmount?: number | null, calculatorNetPrice?: number | null }, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> }, criteria: { __typename?: 'FinanceCriteria', financeProduct: { __typename?: 'FinanceProduct', displayLabel: string, id: string }, paymentFrequency: { __typename?: 'PaymentFrequency', displayLabel: string, id: string }, term: { __typename?: 'Term', value: number, unit: TermUnit }, deposits: Array<{ __typename?: 'DepositCriteria', percentageValue: number, value: { __typename?: 'Money', amount: number, currency: string } }>, mileage?: { __typename?: 'Mileage', value: number } | null, interestRate?: { __typename?: 'InterestRate', value: number } | null, homeOwner?: { __typename?: 'HomeOwner', value: boolean } | null, residualValue?: { __typename?: 'ResidualValue', value: number } | null } } | null, car: { __typename?: 'QuoteCar', code: string, displayName: string, aggregatedOptions: string, configurationSourceUrl: string, isForReservation?: boolean | null, images: Array<{ __typename?: 'Image', url?: string | null, type?: string | null }>, attributes: { __typename?: 'QuoteCarAttributes', startConfigurationSourceUrl?: string | null, priceLabel?: string | null, deliveryTimeFrame?: { __typename?: 'DeliveryTimeFrame', deliveryTimeFrameLabel?: string | null } | null, freebies?: Array<{ __typename?: 'Freebies', code?: string | null, label?: string | null } | null> | null }, stock?: { __typename?: 'DealStock', vin?: string | null, dms?: string | null, stockType?: StockType | null, attributes?: string | null } | null, trimLevels: { __typename?: 'TrimLevels', nameplate?: { __typename?: 'Nameplate', code: string, attributes?: { __typename?: 'NameplateAttributes', brand?: string | null, shortname?: string | null } | null } | null, model?: { __typename?: 'Model', code: string, attributes?: { __typename?: 'ModelAttributes', modelyear?: string | null, longdescription?: string | null, shortname?: string | null } | null } | null, engine?: { __typename?: 'Engine', attributes?: { __typename?: 'EngineAttributes', shortname?: string | null, longdescription?: string | null, fuelType?: string | null, fuelLabel?: string | null, powertrain?: string | null, capacity?: string | null, maximumpower?: string | null, enginepower?: string | null, maximumtorque?: string | null, transmissionLabel?: string | null, transmissionType?: string | null } | null } | null, bodyStyle?: { __typename?: 'BodyStyle', attributes?: { __typename?: 'BodyStyleAttributes', bodyStyleType?: string | null, longdescription?: string | null, oemcode?: string | null, shortname?: string | null } | null } | null, specificationPack?: { __typename?: 'SpecPack', attributes?: { __typename?: 'SpecPackAttributes', nviccode?: string | null, shortname?: string | null } | null } | null }, features: { __typename?: 'QuoteCarFeatures', selectedFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }>, selectedExtraFeatures?: Array<{ __typename?: 'QuoteCarExtraFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarExtraFeatureAttributes', categoryCode?: string | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null> | null, interior?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, exterior: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> }, roof?: { __typename?: 'QuoteCarFeature', code: string, label: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null, oemcode?: string | null, childrenDetails?: Array<{ __typename?: 'ExtraFeature', id?: number | null, shortname: string, categoryCode?: string | null, code: string } | null> | null }, prices: Array<{ __typename?: 'Price', money: { __typename?: 'Money', amount: number, currency: string } }> } | null, standardFeatures: Array<{ __typename?: 'QuoteCarFeature', code: string, shortName: string, id: string, attributes: { __typename?: 'QuoteCarFeatureAttributes', categoryCode?: string | null } }> } } }, attributes: { __typename?: 'DealAttributes', co2?: number | null, range?: number | null, tradeIn?: boolean | null, tradeInMake?: string | null, tradeInModel?: string | null, tradeInYear?: string | null, tradeInMileage?: string | null, tradeInRegistrationNumber?: string | null, tradeInComment?: string | null, isDistributionStock?: boolean | null, showErrorModal?: boolean | null, tradeInColour?: string | null, tradeInVariant?: string | null, governmentEvRebate?: number | null, totalPurchaseAmount?: number | null, vehicleDetailsPageUrl?: string | null, paymentFee?: { __typename?: 'PaymentFee', paymentType?: PaymentType | null, refundableState?: string | null, inStoreDescription?: string | null, reserveFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, orderFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, fullPaymentFee?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, inStorePaymentFee?: { __typename?: 'Money', amount: number, currency: string } | null } | null, salesEnablement?: { __typename?: 'SalesEnablementDealAttributes', additionalNotes?: string | null, tradeIn?: { __typename?: 'TradeIn', tradeInAmount?: number | null, amountPayable?: number | null } | null } | null } } } | null>, pageInfo: { __typename?: 'PageInfoData', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetFinanceApplicationQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetFinanceApplicationQuery = { __typename?: 'Query', deal: { __typename?: 'Deal', financeApplication?: { __typename?: 'FinanceApplication', status?: string | null, result?: string | null, lender?: string | null, productId?: string | null, createdAt?: string | null, finance?: { __typename?: 'FinanceApplicationFinance', formInput?: { __typename?: 'FinanceFormInputData', financeProductId?: string | null, paymentType: FinanceFormType } | null, simulation?: { __typename?: 'DealFinanceSimulation', comparisonRate?: number | null, frequency: string, interestRate?: number | null, financeProductId?: string | null, deposit: Array<{ __typename?: 'Money', amount: number, currency: string }>, paymentValue?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, loanTermPeriod: { __typename?: 'LoanTermPeriod', value?: number | null, unit?: LoanTermPeriodUnit | null }, totalAmountPayable?: Array<{ __typename?: 'Money', amount: number, currency: string }> | null, attributes?: { __typename?: 'DealFinanceAttributes', residualAmount?: Array<{ __typename?: 'FinanceValue', amount: number, currency: string } | null> | null } | null } | null } | null, disclaimers: Array<{ __typename?: 'FinanceInfoDisclaimer', purpose: string, value: string }> } | null, finance?: { __typename?: 'DealFinance', simulation?: { __typename?: 'DealFinanceSimulation', financePackageId?: string | null, financeProductName?: string | null } | null } | null } };

export type GetMyInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInformationQuery = { __typename?: 'Query', myAccount: { __typename?: 'MyAccountQuery', currentUser: { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, attributes?: { __typename?: 'CustomerAttributes', preferredDealer?: string | null, preferredDealerKey?: string | null } | null } } };

export type GetPartialNricQueryVariables = Exact<{
  state: Scalars['String'];
}>;


export type GetPartialNricQuery = { __typename?: 'Query', oauth: { __typename?: 'OAuthQuery', getPartialNRIC?: string | null } };

export type GetAuthenticationRegisterFormQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['String']>;
}>;


export type GetAuthenticationRegisterFormQuery = { __typename?: 'Query', authentication: { __typename?: 'AuthenticationQuery', registerForm: { __typename?: 'MyAccountJsonSchemaForm', schema: string, uiSchema: string, formData: string } } };

export type IsPasswordResetTokenValidQueryVariables = Exact<{
  resetToken: Scalars['String'];
}>;


export type IsPasswordResetTokenValidQuery = { __typename?: 'Query', isPasswordResetTokenValid: boolean };

export type MyAccountRedirectTargetQueryVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type MyAccountRedirectTargetQuery = { __typename?: 'Query', myAccountRedirectTarget: MyAccountRedirectTarget };

export type StartFinanceApplicationMutationVariables = Exact<{
  dealId: Scalars['String'];
  financeApplicationJourney?: InputMaybe<FinanceApplicationJourney>;
}>;


export type StartFinanceApplicationMutation = { __typename?: 'Mutation', startFinanceApplication: { __typename?: 'FinanceApplication', code?: string | null } };

export type SaveInsuranceApplicationFormMutationVariables = Exact<{
  dealId: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
  identityVerificationState?: InputMaybe<Scalars['String']>;
}>;


export type SaveInsuranceApplicationFormMutation = { __typename?: 'Mutation', insurance: { __typename?: 'InsuranceMutation', submitApplicationForm: { __typename?: 'InsuranceJsonSchema', formData: string } } };

export type GetInsuranceApplicationFormQueryVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type GetInsuranceApplicationFormQuery = { __typename?: 'Query', insurance: { __typename?: 'Insurance', loadApplicationForm: { __typename?: 'InsuranceJsonSchema', schema: string, uiSchema: string, formData: string } } };

export type GetValidateApplicationFormQueryVariables = Exact<{
  dealId: Scalars['String'];
  insuranceFormInput?: InputMaybe<InsuranceFormInput>;
}>;


export type GetValidateApplicationFormQuery = { __typename?: 'Query', insurance: { __typename?: 'Insurance', validateApplicationForm: string } };

export const BaseImageFragmentDoc = gql`
    fragment BaseImage on Image {
  url
  type
}
    `;
export const MoneyFragmentDoc = gql`
    fragment Money on Money {
  amount
  currency
}
    `;
export const InteriorFragmentDoc = gql`
    fragment Interior on Interior {
  shortname
  categoryCode
  code
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const ExteriorFragmentDoc = gql`
    fragment Exterior on Exterior {
  code
  categoryCode
  shortname
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const VariantFragmentDoc = gql`
    fragment Variant on Variant {
  code
  attributes {
    name
    year
    modelName
    fullSpecsUrl
  }
}
    `;
export const ModelFragmentDoc = gql`
    fragment Model on Model {
  code
  attributes {
    oemcode
    shortname
    modelyear
    brand
    fullSpecsUrl
    longdescription
    label
  }
}
    `;
export const EngineFragmentDoc = gql`
    fragment Engine on Engine {
  code
  attributes {
    shortname
    shortdescription
    longdescription
    fuelType
    fuelLabel
    powertrain
    capacity
    transmissionLabel
    maximumpower
    maximumtorque
    enginepower
    transmissionType
    acceleration
    fueleconomy_wltpconsumption_teh
  }
}
    `;
export const SpecPackFragmentDoc = gql`
    fragment SpecPack on SpecPack {
  code
  attributes {
    shortname
    nviccode
  }
}
    `;
export const PriceWithTaxFragmentDoc = gql`
    fragment PriceWithTax on Price {
  money {
    ...Money
  }
  taxes {
    aggregated
    type
    money {
      ...Money
    }
    aggregated
    label
  }
  type
}
    ${MoneyFragmentDoc}`;
export const BadgeFragmentDoc = gql`
    fragment Badge on Badge {
  image
  label
}
    `;
export const DiscountFragmentDoc = gql`
    fragment Discount on Discount {
  code
  badge {
    ...Badge
  }
  label
  value {
    ...Money
  }
  disclaimer
}
    ${BadgeFragmentDoc}
${MoneyFragmentDoc}`;
export const OffersFragmentDoc = gql`
    fragment Offers on Offers {
  badge {
    ...Badge
  }
  discounts {
    ...Discount
  }
}
    ${BadgeFragmentDoc}
${DiscountFragmentDoc}`;
export const DealCarPriceFragmentDoc = gql`
    fragment DealCarPrice on DealCarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const PriceFragmentDoc = gql`
    fragment Price on Price {
  money {
    ...Money
  }
  type
}
    ${MoneyFragmentDoc}`;
export const DealFeatureFragmentDoc = gql`
    fragment DealFeature on DealFeature {
  id
  shortname
  code
  categoryCode
  prices {
    ...Price
  }
  attributes {
    childrenDetails {
      id
      shortname
      categoryCode
      code
    }
  }
}
    ${PriceFragmentDoc}`;
export const PaymentInfoFragmentDoc = gql`
    fragment PaymentInfo on PaymentInfo {
  errorCode
  errorMessage
  actionCode
  actionDescription
  transactionId
  transactionTime
  card
  brand
}
    `;
export const ExpressionOfInterestFragmentDoc = gql`
    fragment ExpressionOfInterest on ExpressionOfInterest {
  code
  enabled
  attributes {
    picture
    label
    description
  }
}
    `;
export const DealerFragmentDoc = gql`
    fragment Dealer on Dealer {
  externalId
  attributes {
    publicToken
  }
  label
  address {
    name
    address
    city
    phone
  }
  postCode
}
    `;
export const FinanceValueFragmentDoc = gql`
    fragment FinanceValue on FinanceValue {
  amount
  currency
}
    `;
export const DealFinanceFragmentDoc = gql`
    fragment DealFinance on DealFinance {
  type
  formInput {
    paymentType
    financeProductId
    term
    deposit
    interestRate
    mileage
    homeOwner
  }
  simulation {
    amountPayable {
      ...Money
    }
    totalAmountPayable {
      ...Money
    }
    comparisonRate
    interestRate
    loanTermPeriod {
      unit
      value
    }
    paymentValue {
      ...Money
    }
    frequency
    deposit {
      ...Money
    }
    attributes {
      upfrontFees {
        ...FinanceValue
      }
      residualAmount {
        ...FinanceValue
      }
      depositAmountPercentage
      calculatorNetPrice
      balloonAmountPercentage
      residualAmountPercentage
      cae
    }
    financePackageId
    financeProductId
    financeProductName
    oneForOne
    roadCosts
  }
  breakdown {
    schema
  }
}
    ${MoneyFragmentDoc}
${FinanceValueFragmentDoc}`;
export const CustomerAttributesFragmentDoc = gql`
    fragment CustomerAttributes on CustomerAttributes {
  salutation
  postCode
  street
  city
  state
  country
  areaCode
  areaCodeKey
  preferredContactMethod
  identificationNumber
}
    `;
export const CustomerDetailsFragmentDoc = gql`
    fragment CustomerDetails on Customer {
  salutation
  firstName
  lastName
  phone
  email
  identificationNumber
  marketingInformation
  companyName
  customerType
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const AppointmentDetailsFragmentDoc = gql`
    fragment AppointmentDetails on Appointment {
  preferredDate
  preferredTime
  attributes {
    comments
    salesConsultant
  }
}
    `;
export const PaymentFeeFragmentDoc = gql`
    fragment PaymentFee on PaymentFee {
  reserveFee {
    ...Money
  }
  orderFee {
    ...Money
  }
  fullPaymentFee {
    ...Money
  }
  paymentType
  refundableState
  inStorePaymentFee {
    ...Money
  }
  inStoreDescription
}
    ${MoneyFragmentDoc}`;
export const DealDataFragmentDoc = gql`
    fragment DealData on Deal {
  uuid
  disabled
  disabledReasons
  car {
    code
    displayName
    images {
      ...BaseImage
    }
    stock {
      vin
      dms
      stockType
      attributes
    }
    aggregatedOptions
    configurationSourceUrl
    nameplate {
      code
      attributes {
        brand
        shortname
        modelyear
        oemcode
      }
    }
    interior {
      ...Interior
    }
    exterior {
      ...Exterior
    }
    variant {
      ...Variant
    }
    model {
      ...Model
    }
    engine {
      ...Engine
    }
    specPack {
      ...SpecPack
    }
    bodyStyle {
      attributes {
        bodyStyleType
        longdescription
        oemcode
      }
    }
    prices {
      carPrice {
        ...DealCarPrice
      }
      totalPrice {
        ...PriceWithTax
      }
      totalConfiguration {
        ...Price
      }
      totalFeatures {
        ...Price
      }
      discounts {
        ...Discount
      }
      totalOfferFeatures {
        ...Price
      }
      totalNonFinanceableFeatures {
        ...Price
      }
    }
    standardFeatures {
      ...DealFeature
    }
    selectedFeatures {
      ...DealFeature
    }
    disclaimers {
      value
      purpose
      needsToBeTranslated
    }
    attributes {
      coeCategoryAmount {
        amount
        currency
      }
      freebies {
        code
        label
      }
      priceLabel
    }
  }
  paymentInfo {
    ...PaymentInfo
  }
  expressionsOfInterest {
    ...ExpressionOfInterest
  }
  insurance {
    applicationStatus
    applicationDate
    applicationAmended
    policy {
      money {
        ...Money
      }
    }
  }
  dealer {
    ...Dealer
  }
  finance {
    ...DealFinance
  }
  financeApplication {
    result
    status
    submissionId
    callbackRequested
    financeApplicationJourney
  }
  customer {
    ...CustomerDetails
  }
  appointment {
    ...AppointmentDetails
  }
  location {
    province
    district
    street
  }
  attributes {
    market
    modelyear
    co2
    range
    paymentFee {
      ...PaymentFee
    }
    tradeIn
    tradeInMake
    tradeInModel
    tradeInYear
    tradeInMileage
    tradeInRegistrationNumber
    tradeInComment
    isDistributionStock
    showErrorModal
    governmentEvRebate
    totalPurchaseAmount
    tradeInColour
    tradeInVariant
    vehicleDetailsPageUrl
    salesEnablement {
      additionalNotes
      tradeIn {
        tradeInAmount
        amountPayable
      }
    }
  }
  status
  journeyType
  currency
  region
  country
  brand
  language
  createdAt
  updatedAt
}
    ${BaseImageFragmentDoc}
${InteriorFragmentDoc}
${ExteriorFragmentDoc}
${VariantFragmentDoc}
${ModelFragmentDoc}
${EngineFragmentDoc}
${SpecPackFragmentDoc}
${DealCarPriceFragmentDoc}
${PriceWithTaxFragmentDoc}
${PriceFragmentDoc}
${DiscountFragmentDoc}
${DealFeatureFragmentDoc}
${PaymentInfoFragmentDoc}
${ExpressionOfInterestFragmentDoc}
${MoneyFragmentDoc}
${DealerFragmentDoc}
${DealFinanceFragmentDoc}
${CustomerDetailsFragmentDoc}
${AppointmentDetailsFragmentDoc}
${PaymentFeeFragmentDoc}`;
export const MountedFeatureFragmentDoc = gql`
    fragment MountedFeature on MountedFeature {
  code
  shortname
  image {
    url
  }
}
    `;
export const MountedFeaturesFragmentDoc = gql`
    fragment MountedFeatures on MountedFeatures {
  exterior {
    ...MountedFeature
  }
  interior {
    ...MountedFeature
  }
}
    ${MountedFeatureFragmentDoc}`;
export const CarPricesFragmentDoc = gql`
    fragment CarPrices on CarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const QuotePricesFragmentDoc = gql`
    fragment QuotePrices on Prices {
  carPrice {
    ...CarPrices
  }
  totalPrice {
    ...PriceWithTax
  }
  totalConfiguration {
    ...Price
  }
  totalFeatures {
    ...Price
  }
  discounts {
    ...Discount
  }
  totalOfferFeatures {
    ...Price
  }
}
    ${CarPricesFragmentDoc}
${PriceWithTaxFragmentDoc}
${PriceFragmentDoc}
${DiscountFragmentDoc}`;
export const QuoteFinanceFragmentDoc = gql`
    fragment QuoteFinance on FinanceQuote {
  criteria {
    financeProduct {
      displayLabel
      id
    }
    paymentFrequency {
      displayLabel
      id
    }
    term {
      value
      unit
    }
    deposits {
      value {
        ...Money
      }
      percentageValue
    }
    mileage {
      value
    }
    interestRate {
      value
    }
    homeOwner {
      value
    }
    residualValue {
      value
    }
  }
  simulation {
    value {
      currency
      amount
    }
    totalAmountPayable {
      currency
      amount
    }
    amountFinanced {
      currency
      amount
    }
    interestRate {
      value
    }
    attributes {
      comparisonRate
      oneForOne
      balloonAmountPercentage
      depositAmountPercentage
      residualAmountPercentage
      cae
      upfrontFees
      residualAmount
      calculatorNetPrice
    }
    disclaimers {
      purpose
      value
    }
  }
}
    ${MoneyFragmentDoc}`;
export const DisclaimerFragmentDoc = gql`
    fragment Disclaimer on Disclaimer {
  value
  purpose
  needsToBeTranslated
}
    `;
export const CommonQuoteMinimalFragmentDoc = gql`
    fragment CommonQuoteMinimal on QuoteMinimal {
  prices {
    ...QuotePrices
  }
  offers {
    badge {
      image
      label
    }
  }
  finance {
    type
    quote {
      ...QuoteFinance
    }
    disclaimers {
      ...Disclaimer
    }
    editText
  }
  disclaimers {
    ...Disclaimer
  }
}
    ${QuotePricesFragmentDoc}
${QuoteFinanceFragmentDoc}
${DisclaimerFragmentDoc}`;
export const CheckoutBodyStyleFragmentDoc = gql`
    fragment CheckoutBodyStyle on BodyStyle {
  code
  attributes {
    shortname
    longdescription
    bodyStyleType @include(if: $dataLayer)
    oemcode @include(if: $dataLayer)
  }
}
    `;
export const CarPriceWithTaxFragmentDoc = gql`
    fragment CarPriceWithTax on CarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const CriteriaFragmentDoc = gql`
    fragment Criteria on FinanceCriteria {
  financeProduct {
    id
    displayLabel
  }
  paymentFrequency {
    id
    displayLabel
  }
  term {
    value
  }
  deposits {
    value {
      amount
      currency
    }
  }
  mileage {
    value
  }
  ageRange {
    value
  }
  homeOwner {
    value
  }
  residualValue {
    value
  }
}
    `;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  firstName
  lastName
  phone
  email
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const QuoteTrimLevelsFragmentDoc = gql`
    fragment QuoteTrimLevels on TrimLevels {
  nameplate {
    code
    attributes {
      brand @include(if: $dataLayer)
      shortname
    }
  }
  model {
    attributes {
      modelyear @include(if: $dataLayer)
      longdescription @include(if: $dataLayer)
      shortname
    }
    code
  }
  engine {
    attributes {
      shortname
      longdescription @include(if: $dataLayer)
      fuelType @include(if: $dataLayer)
      fuelLabel @include(if: $dataLayer)
      powertrain @include(if: $dataLayer)
      capacity @include(if: $dataLayer)
      maximumpower @include(if: $dataLayer)
      enginepower @include(if: $dataLayer)
      maximumtorque @include(if: $dataLayer)
      transmissionLabel
      transmissionType @include(if: $dataLayer)
    }
  }
  bodyStyle {
    attributes {
      bodyStyleType @include(if: $dataLayer)
      longdescription @include(if: $dataLayer)
      oemcode @include(if: $dataLayer)
      shortname
    }
  }
  specificationPack {
    attributes {
      nviccode @include(if: $dataLayer)
      shortname
    }
  }
}
    `;
export const QuoteFeatureFragmentDoc = gql`
    fragment QuoteFeature on QuoteCarFeature {
  code
  label
  shortName
  attributes {
    categoryCode
    oemcode
    childrenDetails {
      id
      shortname
      categoryCode
      code
    }
  }
  prices {
    money {
      ...Money
    }
  }
  id
}
    ${MoneyFragmentDoc}`;
export const QuoteExtraFeatureFragmentDoc = gql`
    fragment QuoteExtraFeature on QuoteCarExtraFeature {
  code
  shortName
  attributes {
    categoryCode
  }
  prices {
    money {
      ...Money
    }
  }
  id
}
    ${MoneyFragmentDoc}`;
export const QuoteCarFragmentDoc = gql`
    fragment QuoteCar on QuoteCar {
  code
  displayName
  images {
    ...BaseImage
  }
  attributes {
    startConfigurationSourceUrl
    deliveryTimeFrame {
      deliveryTimeFrameLabel
    }
    freebies {
      code
      label
    }
    priceLabel
  }
  stock {
    vin
    dms
    stockType
    attributes
  }
  aggregatedOptions
  configurationSourceUrl
  trimLevels {
    ...QuoteTrimLevels
  }
  isForReservation
  features {
    selectedFeatures {
      ...QuoteFeature
    }
    selectedExtraFeatures {
      ...QuoteExtraFeature
    }
    interior {
      ...QuoteFeature
    }
    exterior {
      ...QuoteFeature
    }
    roof {
      ...QuoteFeature
    }
    standardFeatures {
      code
      shortName
      attributes {
        categoryCode
      }
      id
    }
  }
}
    ${BaseImageFragmentDoc}
${QuoteTrimLevelsFragmentDoc}
${QuoteFeatureFragmentDoc}
${QuoteExtraFeatureFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on Quote {
  id
  prices {
    ...QuotePrices
  }
  disclaimers {
    ...Disclaimer
  }
  offers {
    badge {
      image
      label
    }
  }
  finance {
    simulation {
      roadCosts
    }
    ...QuoteFinance
  }
  car {
    ...QuoteCar
  }
}
    ${QuotePricesFragmentDoc}
${DisclaimerFragmentDoc}
${QuoteFinanceFragmentDoc}
${QuoteCarFragmentDoc}`;
export const DealWithQuoteFragmentDoc = gql`
    fragment DealWithQuote on DealWithQuote {
  uuid
  disabledReasons
  paymentInfo @include(if: $isPayment) {
    ...PaymentInfo
  }
  expressionsOfInterest {
    ...ExpressionOfInterest
  }
  dealer {
    ...Dealer
  }
  customer {
    ...CustomerDetails
  }
  appointment {
    preferredDate
    preferredTime
    attributes {
      comments
      salesConsultant
    }
  }
  quote {
    ...Quote
  }
  status
  journeyType
  attributes {
    co2
    range
    paymentFee {
      ...PaymentFee
    }
    tradeIn
    tradeInMake
    tradeInModel
    tradeInYear
    tradeInMileage
    tradeInRegistrationNumber
    tradeInComment
    isDistributionStock
    showErrorModal
    tradeInColour
    tradeInVariant
    governmentEvRebate
    totalPurchaseAmount
    vehicleDetailsPageUrl
    salesEnablement {
      additionalNotes
      tradeIn {
        tradeInAmount
        amountPayable
      }
    }
  }
}
    ${PaymentInfoFragmentDoc}
${ExpressionOfInterestFragmentDoc}
${DealerFragmentDoc}
${CustomerDetailsFragmentDoc}
${QuoteFragmentDoc}
${PaymentFeeFragmentDoc}`;
export const FinanceFormInputFragmentDoc = gql`
    fragment FinanceFormInput on FinanceFormInputData {
  ageRange
  paymentType
  financeProductId
  financePackageId
  term
  deposit
  interestRate
  partExchangeId
  homeOwner
  mileage
  residualValue
}
    `;
export const StockAttributeFragmentDoc = gql`
    fragment StockAttribute on StockAttribute {
  code
  shortname
}
    `;
export const ListingAttributesFragmentDoc = gql`
    fragment ListingAttributes on StockAttributes {
  vin {
    ...StockAttribute
  }
  exteriorLabel
  interiorLabel
  stockDate {
    ...StockAttribute
  }
  make {
    ...StockAttribute
  }
  modelNumber {
    ...StockAttribute
  }
  engineCode {
    ...StockAttribute
  }
  modelCode {
    ...StockAttribute
  }
  engineNumber {
    ...StockAttribute
  }
  licenseNumber {
    ...StockAttribute
  }
  subModelId {
    ...StockAttribute
  }
  locationCode {
    ...StockAttribute
  }
  status {
    ...StockAttribute
  }
  inventorySource {
    ...StockAttribute
  }
}
    ${StockAttributeFragmentDoc}`;
export const ListingFeaturesFragmentDoc = gql`
    fragment ListingFeatures on Feature {
  shortname
  code
}
    `;
export const CarPriceFragmentDoc = gql`
    fragment CarPrice on CarPrice {
  originalPrice {
    ...Price
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...Price
  }
  offers {
    ...Offers
  }
}
    ${PriceFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const PricesFragmentDoc = gql`
    fragment Prices on Prices {
  carPrice {
    ...CarPrice
  }
  totalFeatures {
    ...Price
  }
  totalConfiguration {
    ...Price
  }
  totalPrice {
    ...Price
  }
}
    ${CarPriceFragmentDoc}
${PriceFragmentDoc}`;
export const FinanceFragmentDoc = gql`
    fragment Finance on FinanceResult {
  type
  simulation {
    paymentValue {
      currency
      amount
    }
    interestRate
    comparisonRate
    frequency
    loanTermPeriod {
      value
      unit
    }
    deposits {
      value
      type
    }
  }
}
    `;
export const SimilarStockCarsFragmentDoc = gql`
    fragment SimilarStockCars on PimStockCar {
  carId
  vin
  selectedFeatures {
    selected
    added
    removed
    merged {
      merged
      into
    }
    requiresOneOf
  }
  images {
    ...BaseImage
  }
  carPrice {
    ...CarPrice
  }
  finance(financeFormInput: $financeFormInput) {
    ...Finance
  }
  carMatchLabel
  keyFeatures {
    id
    shortname
    shortDescription
    longDescription
    code
    categoryCode
  }
}
    ${BaseImageFragmentDoc}
${CarPriceFragmentDoc}
${FinanceFragmentDoc}`;
export const SimulationFragmentDoc = gql`
    fragment Simulation on Simulation {
  value {
    amount
    currency
  }
  totalAmountPayable {
    amount
    currency
  }
  amountFinanced {
    amount
    currency
  }
  interestRate {
    value
  }
}
    `;
export const TaxesFragmentDoc = gql`
    fragment Taxes on Price {
  taxes {
    type
    label
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const SlimDealDataFragmentDoc = gql`
    fragment SlimDealData on Deal {
  uuid
  disabled
  disabledReasons
  car {
    code
    displayName
    images {
      ...BaseImage
    }
    stock {
      vin
      dms
      stockType
    }
    configurationSourceUrl
    nameplate {
      code
      attributes {
        brand
        shortname
        oemcode
      }
    }
    interior {
      ...Interior
    }
    exterior {
      ...Exterior
    }
    variant {
      ...Variant
    }
    model {
      ...Model
    }
    engine {
      ...Engine
    }
    specPack {
      ...SpecPack
    }
    bodyStyle {
      attributes {
        bodyStyleType
        longdescription
        oemcode
      }
    }
    prices {
      carPrice {
        ...DealCarPrice
      }
      totalPrice {
        ...PriceWithTax
      }
      totalConfiguration {
        ...Price
      }
      totalFeatures {
        ...Price
      }
      discounts {
        ...Discount
      }
      totalOfferFeatures {
        ...Price
      }
      totalNonFinanceableFeatures {
        ...Price
      }
    }
    standardFeatures {
      ...DealFeature
    }
    selectedFeatures {
      ...DealFeature
    }
    disclaimers {
      value
      purpose
      needsToBeTranslated
    }
    attributes {
      coeCategoryAmount {
        amount
        currency
      }
      freebies {
        code
        label
      }
      priceLabel
    }
  }
  paymentInfo {
    ...PaymentInfo
  }
  expressionsOfInterest {
    ...ExpressionOfInterest
  }
  insurance {
    applicationStatus
    applicationDate
    applicationAmended
    policy {
      money {
        ...Money
      }
    }
  }
  dealer {
    ...Dealer
  }
  finance {
    ...DealFinance
  }
  financeApplication {
    result
    status
    financeApplicationJourney
  }
  customer {
    ...CustomerDetails
  }
  appointment {
    ...AppointmentDetails
  }
  location {
    district
    street
  }
  attributes {
    market
    co2
    range
    paymentFee {
      ...PaymentFee
    }
    tradeIn
    tradeInMake
    tradeInModel
    tradeInYear
    tradeInMileage
    tradeInRegistrationNumber
    tradeInComment
    isDistributionStock
    showErrorModal
    governmentEvRebate
    totalPurchaseAmount
    tradeInColour
    tradeInVariant
  }
  status
  journeyType
  currency
  region
  country
  brand
  language
  createdAt
  updatedAt
}
    ${BaseImageFragmentDoc}
${InteriorFragmentDoc}
${ExteriorFragmentDoc}
${VariantFragmentDoc}
${ModelFragmentDoc}
${EngineFragmentDoc}
${SpecPackFragmentDoc}
${DealCarPriceFragmentDoc}
${PriceWithTaxFragmentDoc}
${PriceFragmentDoc}
${DiscountFragmentDoc}
${DealFeatureFragmentDoc}
${PaymentInfoFragmentDoc}
${ExpressionOfInterestFragmentDoc}
${MoneyFragmentDoc}
${DealerFragmentDoc}
${DealFinanceFragmentDoc}
${CustomerDetailsFragmentDoc}
${AppointmentDetailsFragmentDoc}
${PaymentFeeFragmentDoc}`;
export const MyAccountDealDataFragmentDoc = gql`
    fragment MyAccountDealData on Deal {
  ...SlimDealData
}
    ${SlimDealDataFragmentDoc}`;
export const GetTranslationsDocument = gql`
    query GetTranslations {
  translations {
    code
    value
  }
}
    `;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = Apollo.QueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export const GetTranslationsByFamilyDocument = gql`
    query getTranslationsByFamily($family: String!) {
  translationsByFamily(family: $family) {
    code
    value
    __typename
  }
}
    `;

/**
 * __useGetTranslationsByFamilyQuery__
 *
 * To run a query within a React component, call `useGetTranslationsByFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsByFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsByFamilyQuery({
 *   variables: {
 *      family: // value for 'family'
 *   },
 * });
 */
export function useGetTranslationsByFamilyQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationsByFamilyQuery, GetTranslationsByFamilyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsByFamilyQuery, GetTranslationsByFamilyQueryVariables>(GetTranslationsByFamilyDocument, options);
      }
export function useGetTranslationsByFamilyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsByFamilyQuery, GetTranslationsByFamilyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsByFamilyQuery, GetTranslationsByFamilyQueryVariables>(GetTranslationsByFamilyDocument, options);
        }
export type GetTranslationsByFamilyQueryHookResult = ReturnType<typeof useGetTranslationsByFamilyQuery>;
export type GetTranslationsByFamilyLazyQueryHookResult = ReturnType<typeof useGetTranslationsByFamilyLazyQuery>;
export type GetTranslationsByFamilyQueryResult = Apollo.QueryResult<GetTranslationsByFamilyQuery, GetTranslationsByFamilyQueryVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!, $confirmedPassword: String!, $dealId: String!) {
  setPassword(
    password: $password
    confirmedPassword: $confirmedPassword
    dealId: $dealId
  )
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      confirmedPassword: // value for 'confirmedPassword'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $newPassword: String!, $confirmedPassword: String!) {
  myAccount {
    changePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
      confirmedPassword: $confirmedPassword
    )
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *      confirmedPassword: // value for 'confirmedPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const LogoutClientDocument = gql`
    mutation LogoutClient {
  myAccount {
    logout
  }
}
    `;
export type LogoutClientMutationFn = Apollo.MutationFunction<LogoutClientMutation, LogoutClientMutationVariables>;

/**
 * __useLogoutClientMutation__
 *
 * To run a mutation, you first call `useLogoutClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutClientMutation, { data, loading, error }] = useLogoutClientMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutClientMutation(baseOptions?: Apollo.MutationHookOptions<LogoutClientMutation, LogoutClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutClientMutation, LogoutClientMutationVariables>(LogoutClientDocument, options);
      }
export type LogoutClientMutationHookResult = ReturnType<typeof useLogoutClientMutation>;
export type LogoutClientMutationResult = Apollo.MutationResult<LogoutClientMutation>;
export type LogoutClientMutationOptions = Apollo.BaseMutationOptions<LogoutClientMutation, LogoutClientMutationVariables>;
export const UpdatePersonalDetailsDocument = gql`
    mutation UpdatePersonalDetails($data: UserDetailsFormData!) {
  myAccount {
    updatePersonalDetails(data: $data) {
      firstName
      lastName
    }
  }
}
    `;
export type UpdatePersonalDetailsMutationFn = Apollo.MutationFunction<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>;

/**
 * __useUpdatePersonalDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalDetailsMutation, { data, loading, error }] = useUpdatePersonalDetailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePersonalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>(UpdatePersonalDetailsDocument, options);
      }
export type UpdatePersonalDetailsMutationHookResult = ReturnType<typeof useUpdatePersonalDetailsMutation>;
export type UpdatePersonalDetailsMutationResult = Apollo.MutationResult<UpdatePersonalDetailsMutation>;
export type UpdatePersonalDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>;
export const GetPersonalDetailsFormDocument = gql`
    query GetPersonalDetailsForm {
  myAccount {
    updatePersonalDetailsForm {
      schema
      uiSchema
      formData
    }
  }
}
    `;

/**
 * __useGetPersonalDetailsFormQuery__
 *
 * To run a query within a React component, call `useGetPersonalDetailsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalDetailsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalDetailsFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalDetailsFormQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalDetailsFormQuery, GetPersonalDetailsFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalDetailsFormQuery, GetPersonalDetailsFormQueryVariables>(GetPersonalDetailsFormDocument, options);
      }
export function useGetPersonalDetailsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalDetailsFormQuery, GetPersonalDetailsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalDetailsFormQuery, GetPersonalDetailsFormQueryVariables>(GetPersonalDetailsFormDocument, options);
        }
export type GetPersonalDetailsFormQueryHookResult = ReturnType<typeof useGetPersonalDetailsFormQuery>;
export type GetPersonalDetailsFormLazyQueryHookResult = ReturnType<typeof useGetPersonalDetailsFormLazyQuery>;
export type GetPersonalDetailsFormQueryResult = Apollo.QueryResult<GetPersonalDetailsFormQuery, GetPersonalDetailsFormQueryVariables>;
export const CheckIfCurrentPasswordIsValidDocument = gql`
    query checkIfCurrentPasswordIsValid($currentPassword: String!) {
  myAccount {
    isCurrentPasswordValid(currentPassword: $currentPassword)
  }
}
    `;

/**
 * __useCheckIfCurrentPasswordIsValidQuery__
 *
 * To run a query within a React component, call `useCheckIfCurrentPasswordIsValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfCurrentPasswordIsValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfCurrentPasswordIsValidQuery({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useCheckIfCurrentPasswordIsValidQuery(baseOptions: Apollo.QueryHookOptions<CheckIfCurrentPasswordIsValidQuery, CheckIfCurrentPasswordIsValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfCurrentPasswordIsValidQuery, CheckIfCurrentPasswordIsValidQueryVariables>(CheckIfCurrentPasswordIsValidDocument, options);
      }
export function useCheckIfCurrentPasswordIsValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfCurrentPasswordIsValidQuery, CheckIfCurrentPasswordIsValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfCurrentPasswordIsValidQuery, CheckIfCurrentPasswordIsValidQueryVariables>(CheckIfCurrentPasswordIsValidDocument, options);
        }
export type CheckIfCurrentPasswordIsValidQueryHookResult = ReturnType<typeof useCheckIfCurrentPasswordIsValidQuery>;
export type CheckIfCurrentPasswordIsValidLazyQueryHookResult = ReturnType<typeof useCheckIfCurrentPasswordIsValidLazyQuery>;
export type CheckIfCurrentPasswordIsValidQueryResult = Apollo.QueryResult<CheckIfCurrentPasswordIsValidQuery, CheckIfCurrentPasswordIsValidQueryVariables>;
export const InitForgotPasswordDocument = gql`
    mutation initForgotPassword($email: String!) {
  initForgotPassword(email: $email)
}
    `;
export type InitForgotPasswordMutationFn = Apollo.MutationFunction<InitForgotPasswordMutation, InitForgotPasswordMutationVariables>;

/**
 * __useInitForgotPasswordMutation__
 *
 * To run a mutation, you first call `useInitForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initForgotPasswordMutation, { data, loading, error }] = useInitForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInitForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<InitForgotPasswordMutation, InitForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitForgotPasswordMutation, InitForgotPasswordMutationVariables>(InitForgotPasswordDocument, options);
      }
export type InitForgotPasswordMutationHookResult = ReturnType<typeof useInitForgotPasswordMutation>;
export type InitForgotPasswordMutationResult = Apollo.MutationResult<InitForgotPasswordMutation>;
export type InitForgotPasswordMutationOptions = Apollo.BaseMutationOptions<InitForgotPasswordMutation, InitForgotPasswordMutationVariables>;
export const SubmitRegisterFormDocument = gql`
    mutation SubmitRegisterForm($data: RegisterFormData!) {
  authentication {
    register(data: $data)
  }
}
    `;
export type SubmitRegisterFormMutationFn = Apollo.MutationFunction<SubmitRegisterFormMutation, SubmitRegisterFormMutationVariables>;

/**
 * __useSubmitRegisterFormMutation__
 *
 * To run a mutation, you first call `useSubmitRegisterFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRegisterFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRegisterFormMutation, { data, loading, error }] = useSubmitRegisterFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitRegisterFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRegisterFormMutation, SubmitRegisterFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRegisterFormMutation, SubmitRegisterFormMutationVariables>(SubmitRegisterFormDocument, options);
      }
export type SubmitRegisterFormMutationHookResult = ReturnType<typeof useSubmitRegisterFormMutation>;
export type SubmitRegisterFormMutationResult = Apollo.MutationResult<SubmitRegisterFormMutation>;
export type SubmitRegisterFormMutationOptions = Apollo.BaseMutationOptions<SubmitRegisterFormMutation, SubmitRegisterFormMutationVariables>;
export const RemoveEnquiriesDocument = gql`
    mutation removeEnquiries($dealId: String!) {
  myAccount {
    removeEnquiries(dealId: $dealId)
  }
}
    `;
export type RemoveEnquiriesMutationFn = Apollo.MutationFunction<RemoveEnquiriesMutation, RemoveEnquiriesMutationVariables>;

/**
 * __useRemoveEnquiriesMutation__
 *
 * To run a mutation, you first call `useRemoveEnquiriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEnquiriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEnquiriesMutation, { data, loading, error }] = useRemoveEnquiriesMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useRemoveEnquiriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEnquiriesMutation, RemoveEnquiriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEnquiriesMutation, RemoveEnquiriesMutationVariables>(RemoveEnquiriesDocument, options);
      }
export type RemoveEnquiriesMutationHookResult = ReturnType<typeof useRemoveEnquiriesMutation>;
export type RemoveEnquiriesMutationResult = Apollo.MutationResult<RemoveEnquiriesMutation>;
export type RemoveEnquiriesMutationOptions = Apollo.BaseMutationOptions<RemoveEnquiriesMutation, RemoveEnquiriesMutationVariables>;
export const RemoveSavedCarDocument = gql`
    mutation removeSavedCar($dealId: String!) {
  myAccount {
    removeSavedCar(dealId: $dealId)
  }
}
    `;
export type RemoveSavedCarMutationFn = Apollo.MutationFunction<RemoveSavedCarMutation, RemoveSavedCarMutationVariables>;

/**
 * __useRemoveSavedCarMutation__
 *
 * To run a mutation, you first call `useRemoveSavedCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedCarMutation, { data, loading, error }] = useRemoveSavedCarMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useRemoveSavedCarMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedCarMutation, RemoveSavedCarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedCarMutation, RemoveSavedCarMutationVariables>(RemoveSavedCarDocument, options);
      }
export type RemoveSavedCarMutationHookResult = ReturnType<typeof useRemoveSavedCarMutation>;
export type RemoveSavedCarMutationResult = Apollo.MutationResult<RemoveSavedCarMutation>;
export type RemoveSavedCarMutationOptions = Apollo.BaseMutationOptions<RemoveSavedCarMutation, RemoveSavedCarMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  myAccount {
    currentUser {
      ...CustomerDetails
    }
  }
}
    ${CustomerDetailsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetDealDocument = gql`
    query GetDeal($token: String!) {
  deal(token: $token) {
    ...DealData
  }
}
    ${DealDataFragmentDoc}`;

/**
 * __useGetDealQuery__
 *
 * To run a query within a React component, call `useGetDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetDealQuery(baseOptions: Apollo.QueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
      }
export function useGetDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
        }
export type GetDealQueryHookResult = ReturnType<typeof useGetDealQuery>;
export type GetDealLazyQueryHookResult = ReturnType<typeof useGetDealLazyQuery>;
export type GetDealQueryResult = Apollo.QueryResult<GetDealQuery, GetDealQueryVariables>;
export const GetDealWithCustomerDocument = gql`
    query GetDealWithCustomer($token: String!) {
  deal(token: $token) {
    customer {
      ...Customer
      __typename
    }
    journeyType
    __typename
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useGetDealWithCustomerQuery__
 *
 * To run a query within a React component, call `useGetDealWithCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealWithCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealWithCustomerQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetDealWithCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetDealWithCustomerQuery, GetDealWithCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealWithCustomerQuery, GetDealWithCustomerQueryVariables>(GetDealWithCustomerDocument, options);
      }
export function useGetDealWithCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealWithCustomerQuery, GetDealWithCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealWithCustomerQuery, GetDealWithCustomerQueryVariables>(GetDealWithCustomerDocument, options);
        }
export type GetDealWithCustomerQueryHookResult = ReturnType<typeof useGetDealWithCustomerQuery>;
export type GetDealWithCustomerLazyQueryHookResult = ReturnType<typeof useGetDealWithCustomerLazyQuery>;
export type GetDealWithCustomerQueryResult = Apollo.QueryResult<GetDealWithCustomerQuery, GetDealWithCustomerQueryVariables>;
export const GetDealWithQuoteDocument = gql`
    query GetDealWithQuote($token: String!, $dataLayer: Boolean! = false, $isPayment: Boolean! = false) {
  dealWithQuote(token: $token) {
    ...DealWithQuote
  }
}
    ${DealWithQuoteFragmentDoc}`;

/**
 * __useGetDealWithQuoteQuery__
 *
 * To run a query within a React component, call `useGetDealWithQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealWithQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealWithQuoteQuery({
 *   variables: {
 *      token: // value for 'token'
 *      dataLayer: // value for 'dataLayer'
 *      isPayment: // value for 'isPayment'
 *   },
 * });
 */
export function useGetDealWithQuoteQuery(baseOptions: Apollo.QueryHookOptions<GetDealWithQuoteQuery, GetDealWithQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealWithQuoteQuery, GetDealWithQuoteQueryVariables>(GetDealWithQuoteDocument, options);
      }
export function useGetDealWithQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealWithQuoteQuery, GetDealWithQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealWithQuoteQuery, GetDealWithQuoteQueryVariables>(GetDealWithQuoteDocument, options);
        }
export type GetDealWithQuoteQueryHookResult = ReturnType<typeof useGetDealWithQuoteQuery>;
export type GetDealWithQuoteLazyQueryHookResult = ReturnType<typeof useGetDealWithQuoteLazyQuery>;
export type GetDealWithQuoteQueryResult = Apollo.QueryResult<GetDealWithQuoteQuery, GetDealWithQuoteQueryVariables>;
export const GetDealsPageDocument = gql`
    query GetDealsPage($first: Int!, $after: String, $dealTypes: [DealTypes!], $withFinance: Boolean, $withInsurance: Boolean) {
  myAccount {
    dealsPage(
      first: $first
      after: $after
      dealTypes: $dealTypes
      withFinance: $withFinance
      withInsurance: $withInsurance
    ) {
      edges {
        node {
          ...MyAccountDealData
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${MyAccountDealDataFragmentDoc}`;

/**
 * __useGetDealsPageQuery__
 *
 * To run a query within a React component, call `useGetDealsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsPageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      dealTypes: // value for 'dealTypes'
 *      withFinance: // value for 'withFinance'
 *      withInsurance: // value for 'withInsurance'
 *   },
 * });
 */
export function useGetDealsPageQuery(baseOptions: Apollo.QueryHookOptions<GetDealsPageQuery, GetDealsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsPageQuery, GetDealsPageQueryVariables>(GetDealsPageDocument, options);
      }
export function useGetDealsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsPageQuery, GetDealsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsPageQuery, GetDealsPageQueryVariables>(GetDealsPageDocument, options);
        }
export type GetDealsPageQueryHookResult = ReturnType<typeof useGetDealsPageQuery>;
export type GetDealsPageLazyQueryHookResult = ReturnType<typeof useGetDealsPageLazyQuery>;
export type GetDealsPageQueryResult = Apollo.QueryResult<GetDealsPageQuery, GetDealsPageQueryVariables>;
export const GetDealsWithQuotePageDocument = gql`
    query GetDealsWithQuotePage($first: Int!, $after: String, $dealTypes: [DealTypes!], $withFinance: Boolean, $withInsurance: Boolean, $isPayment: Boolean! = false, $dataLayer: Boolean! = false) {
  myAccount {
    dealWithQuotePage(
      first: $first
      after: $after
      dealTypes: $dealTypes
      withFinance: $withFinance
      withInsurance: $withInsurance
    ) {
      edges {
        node {
          ...DealWithQuote
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${DealWithQuoteFragmentDoc}`;

/**
 * __useGetDealsWithQuotePageQuery__
 *
 * To run a query within a React component, call `useGetDealsWithQuotePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsWithQuotePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsWithQuotePageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      dealTypes: // value for 'dealTypes'
 *      withFinance: // value for 'withFinance'
 *      withInsurance: // value for 'withInsurance'
 *      isPayment: // value for 'isPayment'
 *      dataLayer: // value for 'dataLayer'
 *   },
 * });
 */
export function useGetDealsWithQuotePageQuery(baseOptions: Apollo.QueryHookOptions<GetDealsWithQuotePageQuery, GetDealsWithQuotePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsWithQuotePageQuery, GetDealsWithQuotePageQueryVariables>(GetDealsWithQuotePageDocument, options);
      }
export function useGetDealsWithQuotePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsWithQuotePageQuery, GetDealsWithQuotePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsWithQuotePageQuery, GetDealsWithQuotePageQueryVariables>(GetDealsWithQuotePageDocument, options);
        }
export type GetDealsWithQuotePageQueryHookResult = ReturnType<typeof useGetDealsWithQuotePageQuery>;
export type GetDealsWithQuotePageLazyQueryHookResult = ReturnType<typeof useGetDealsWithQuotePageLazyQuery>;
export type GetDealsWithQuotePageQueryResult = Apollo.QueryResult<GetDealsWithQuotePageQuery, GetDealsWithQuotePageQueryVariables>;
export const GetFinanceApplicationDocument = gql`
    query GetFinanceApplication($token: String!) {
  deal(token: $token) {
    financeApplication {
      status
      result
      lender
      productId
      createdAt
      finance {
        formInput {
          financeProductId
          paymentType
        }
        simulation {
          comparisonRate
          deposit {
            amount
            currency
          }
          paymentValue {
            amount
            currency
          }
          frequency
          loanTermPeriod {
            value
            unit
          }
          interestRate
          totalAmountPayable {
            amount
            currency
          }
          attributes {
            residualAmount {
              amount
              currency
            }
          }
          financeProductId
        }
      }
      disclaimers {
        purpose
        value
      }
    }
    finance {
      simulation {
        financePackageId
        financeProductName
      }
    }
  }
}
    `;

/**
 * __useGetFinanceApplicationQuery__
 *
 * To run a query within a React component, call `useGetFinanceApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinanceApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinanceApplicationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetFinanceApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetFinanceApplicationQuery, GetFinanceApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinanceApplicationQuery, GetFinanceApplicationQueryVariables>(GetFinanceApplicationDocument, options);
      }
export function useGetFinanceApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinanceApplicationQuery, GetFinanceApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinanceApplicationQuery, GetFinanceApplicationQueryVariables>(GetFinanceApplicationDocument, options);
        }
export type GetFinanceApplicationQueryHookResult = ReturnType<typeof useGetFinanceApplicationQuery>;
export type GetFinanceApplicationLazyQueryHookResult = ReturnType<typeof useGetFinanceApplicationLazyQuery>;
export type GetFinanceApplicationQueryResult = Apollo.QueryResult<GetFinanceApplicationQuery, GetFinanceApplicationQueryVariables>;
export const GetMyInformationDocument = gql`
    query GetMyInformation {
  myAccount {
    currentUser {
      firstName
      lastName
      attributes {
        preferredDealer
        preferredDealerKey
      }
    }
  }
}
    `;

/**
 * __useGetMyInformationQuery__
 *
 * To run a query within a React component, call `useGetMyInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInformationQuery, GetMyInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInformationQuery, GetMyInformationQueryVariables>(GetMyInformationDocument, options);
      }
export function useGetMyInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInformationQuery, GetMyInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInformationQuery, GetMyInformationQueryVariables>(GetMyInformationDocument, options);
        }
export type GetMyInformationQueryHookResult = ReturnType<typeof useGetMyInformationQuery>;
export type GetMyInformationLazyQueryHookResult = ReturnType<typeof useGetMyInformationLazyQuery>;
export type GetMyInformationQueryResult = Apollo.QueryResult<GetMyInformationQuery, GetMyInformationQueryVariables>;
export const GetPartialNricDocument = gql`
    query GetPartialNRIC($state: String!) {
  oauth {
    getPartialNRIC(state: $state)
  }
}
    `;

/**
 * __useGetPartialNricQuery__
 *
 * To run a query within a React component, call `useGetPartialNricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartialNricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartialNricQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetPartialNricQuery(baseOptions: Apollo.QueryHookOptions<GetPartialNricQuery, GetPartialNricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartialNricQuery, GetPartialNricQueryVariables>(GetPartialNricDocument, options);
      }
export function useGetPartialNricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartialNricQuery, GetPartialNricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartialNricQuery, GetPartialNricQueryVariables>(GetPartialNricDocument, options);
        }
export type GetPartialNricQueryHookResult = ReturnType<typeof useGetPartialNricQuery>;
export type GetPartialNricLazyQueryHookResult = ReturnType<typeof useGetPartialNricLazyQuery>;
export type GetPartialNricQueryResult = Apollo.QueryResult<GetPartialNricQuery, GetPartialNricQueryVariables>;
export const GetAuthenticationRegisterFormDocument = gql`
    query GetAuthenticationRegisterForm($dealId: String) {
  authentication {
    registerForm(dealId: $dealId) {
      schema
      uiSchema
      formData
    }
  }
}
    `;

/**
 * __useGetAuthenticationRegisterFormQuery__
 *
 * To run a query within a React component, call `useGetAuthenticationRegisterFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticationRegisterFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticationRegisterFormQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetAuthenticationRegisterFormQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthenticationRegisterFormQuery, GetAuthenticationRegisterFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthenticationRegisterFormQuery, GetAuthenticationRegisterFormQueryVariables>(GetAuthenticationRegisterFormDocument, options);
      }
export function useGetAuthenticationRegisterFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthenticationRegisterFormQuery, GetAuthenticationRegisterFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthenticationRegisterFormQuery, GetAuthenticationRegisterFormQueryVariables>(GetAuthenticationRegisterFormDocument, options);
        }
export type GetAuthenticationRegisterFormQueryHookResult = ReturnType<typeof useGetAuthenticationRegisterFormQuery>;
export type GetAuthenticationRegisterFormLazyQueryHookResult = ReturnType<typeof useGetAuthenticationRegisterFormLazyQuery>;
export type GetAuthenticationRegisterFormQueryResult = Apollo.QueryResult<GetAuthenticationRegisterFormQuery, GetAuthenticationRegisterFormQueryVariables>;
export const IsPasswordResetTokenValidDocument = gql`
    query isPasswordResetTokenValid($resetToken: String!) {
  isPasswordResetTokenValid(resetToken: $resetToken)
}
    `;

/**
 * __useIsPasswordResetTokenValidQuery__
 *
 * To run a query within a React component, call `useIsPasswordResetTokenValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPasswordResetTokenValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPasswordResetTokenValidQuery({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useIsPasswordResetTokenValidQuery(baseOptions: Apollo.QueryHookOptions<IsPasswordResetTokenValidQuery, IsPasswordResetTokenValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPasswordResetTokenValidQuery, IsPasswordResetTokenValidQueryVariables>(IsPasswordResetTokenValidDocument, options);
      }
export function useIsPasswordResetTokenValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPasswordResetTokenValidQuery, IsPasswordResetTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPasswordResetTokenValidQuery, IsPasswordResetTokenValidQueryVariables>(IsPasswordResetTokenValidDocument, options);
        }
export type IsPasswordResetTokenValidQueryHookResult = ReturnType<typeof useIsPasswordResetTokenValidQuery>;
export type IsPasswordResetTokenValidLazyQueryHookResult = ReturnType<typeof useIsPasswordResetTokenValidLazyQuery>;
export type IsPasswordResetTokenValidQueryResult = Apollo.QueryResult<IsPasswordResetTokenValidQuery, IsPasswordResetTokenValidQueryVariables>;
export const MyAccountRedirectTargetDocument = gql`
    query MyAccountRedirectTarget($dealId: String!) {
  myAccountRedirectTarget(dealId: $dealId)
}
    `;

/**
 * __useMyAccountRedirectTargetQuery__
 *
 * To run a query within a React component, call `useMyAccountRedirectTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountRedirectTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountRedirectTargetQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useMyAccountRedirectTargetQuery(baseOptions: Apollo.QueryHookOptions<MyAccountRedirectTargetQuery, MyAccountRedirectTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountRedirectTargetQuery, MyAccountRedirectTargetQueryVariables>(MyAccountRedirectTargetDocument, options);
      }
export function useMyAccountRedirectTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountRedirectTargetQuery, MyAccountRedirectTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountRedirectTargetQuery, MyAccountRedirectTargetQueryVariables>(MyAccountRedirectTargetDocument, options);
        }
export type MyAccountRedirectTargetQueryHookResult = ReturnType<typeof useMyAccountRedirectTargetQuery>;
export type MyAccountRedirectTargetLazyQueryHookResult = ReturnType<typeof useMyAccountRedirectTargetLazyQuery>;
export type MyAccountRedirectTargetQueryResult = Apollo.QueryResult<MyAccountRedirectTargetQuery, MyAccountRedirectTargetQueryVariables>;
export const StartFinanceApplicationDocument = gql`
    mutation StartFinanceApplication($dealId: String!, $financeApplicationJourney: FinanceApplicationJourney) {
  startFinanceApplication(
    dealId: $dealId
    financeApplicationJourney: $financeApplicationJourney
  ) {
    code
  }
}
    `;
export type StartFinanceApplicationMutationFn = Apollo.MutationFunction<StartFinanceApplicationMutation, StartFinanceApplicationMutationVariables>;

/**
 * __useStartFinanceApplicationMutation__
 *
 * To run a mutation, you first call `useStartFinanceApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFinanceApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFinanceApplicationMutation, { data, loading, error }] = useStartFinanceApplicationMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      financeApplicationJourney: // value for 'financeApplicationJourney'
 *   },
 * });
 */
export function useStartFinanceApplicationMutation(baseOptions?: Apollo.MutationHookOptions<StartFinanceApplicationMutation, StartFinanceApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFinanceApplicationMutation, StartFinanceApplicationMutationVariables>(StartFinanceApplicationDocument, options);
      }
export type StartFinanceApplicationMutationHookResult = ReturnType<typeof useStartFinanceApplicationMutation>;
export type StartFinanceApplicationMutationResult = Apollo.MutationResult<StartFinanceApplicationMutation>;
export type StartFinanceApplicationMutationOptions = Apollo.BaseMutationOptions<StartFinanceApplicationMutation, StartFinanceApplicationMutationVariables>;
export const SaveInsuranceApplicationFormDocument = gql`
    mutation SaveInsuranceApplicationForm($dealId: String!, $insuranceFormInput: InsuranceFormInput, $identityVerificationState: String) {
  insurance {
    submitApplicationForm(
      dealId: $dealId
      insuranceFormInput: $insuranceFormInput
      identityVerificationState: $identityVerificationState
    ) {
      formData
    }
  }
}
    `;
export type SaveInsuranceApplicationFormMutationFn = Apollo.MutationFunction<SaveInsuranceApplicationFormMutation, SaveInsuranceApplicationFormMutationVariables>;

/**
 * __useSaveInsuranceApplicationFormMutation__
 *
 * To run a mutation, you first call `useSaveInsuranceApplicationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInsuranceApplicationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInsuranceApplicationFormMutation, { data, loading, error }] = useSaveInsuranceApplicationFormMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      insuranceFormInput: // value for 'insuranceFormInput'
 *      identityVerificationState: // value for 'identityVerificationState'
 *   },
 * });
 */
export function useSaveInsuranceApplicationFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveInsuranceApplicationFormMutation, SaveInsuranceApplicationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInsuranceApplicationFormMutation, SaveInsuranceApplicationFormMutationVariables>(SaveInsuranceApplicationFormDocument, options);
      }
export type SaveInsuranceApplicationFormMutationHookResult = ReturnType<typeof useSaveInsuranceApplicationFormMutation>;
export type SaveInsuranceApplicationFormMutationResult = Apollo.MutationResult<SaveInsuranceApplicationFormMutation>;
export type SaveInsuranceApplicationFormMutationOptions = Apollo.BaseMutationOptions<SaveInsuranceApplicationFormMutation, SaveInsuranceApplicationFormMutationVariables>;
export const GetInsuranceApplicationFormDocument = gql`
    query GetInsuranceApplicationForm($dealId: String!) {
  insurance {
    loadApplicationForm(dealId: $dealId) {
      schema
      uiSchema
      formData
    }
  }
}
    `;

/**
 * __useGetInsuranceApplicationFormQuery__
 *
 * To run a query within a React component, call `useGetInsuranceApplicationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceApplicationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceApplicationFormQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetInsuranceApplicationFormQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceApplicationFormQuery, GetInsuranceApplicationFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceApplicationFormQuery, GetInsuranceApplicationFormQueryVariables>(GetInsuranceApplicationFormDocument, options);
      }
export function useGetInsuranceApplicationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceApplicationFormQuery, GetInsuranceApplicationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceApplicationFormQuery, GetInsuranceApplicationFormQueryVariables>(GetInsuranceApplicationFormDocument, options);
        }
export type GetInsuranceApplicationFormQueryHookResult = ReturnType<typeof useGetInsuranceApplicationFormQuery>;
export type GetInsuranceApplicationFormLazyQueryHookResult = ReturnType<typeof useGetInsuranceApplicationFormLazyQuery>;
export type GetInsuranceApplicationFormQueryResult = Apollo.QueryResult<GetInsuranceApplicationFormQuery, GetInsuranceApplicationFormQueryVariables>;
export const GetValidateApplicationFormDocument = gql`
    query GetValidateApplicationForm($dealId: String!, $insuranceFormInput: InsuranceFormInput) {
  insurance {
    validateApplicationForm(
      dealId: $dealId
      insuranceFormInput: $insuranceFormInput
    )
  }
}
    `;

/**
 * __useGetValidateApplicationFormQuery__
 *
 * To run a query within a React component, call `useGetValidateApplicationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidateApplicationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidateApplicationFormQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      insuranceFormInput: // value for 'insuranceFormInput'
 *   },
 * });
 */
export function useGetValidateApplicationFormQuery(baseOptions: Apollo.QueryHookOptions<GetValidateApplicationFormQuery, GetValidateApplicationFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidateApplicationFormQuery, GetValidateApplicationFormQueryVariables>(GetValidateApplicationFormDocument, options);
      }
export function useGetValidateApplicationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidateApplicationFormQuery, GetValidateApplicationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidateApplicationFormQuery, GetValidateApplicationFormQueryVariables>(GetValidateApplicationFormDocument, options);
        }
export type GetValidateApplicationFormQueryHookResult = ReturnType<typeof useGetValidateApplicationFormQuery>;
export type GetValidateApplicationFormLazyQueryHookResult = ReturnType<typeof useGetValidateApplicationFormLazyQuery>;
export type GetValidateApplicationFormQueryResult = Apollo.QueryResult<GetValidateApplicationFormQuery, GetValidateApplicationFormQueryVariables>;